
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h73Jq", function(module, exports) {
module.exports = new URL("square.c546475f.png", import.meta.url).toString();

});

parcelRegister("edFGq", function(module, exports) {
module.exports = new URL("circle.d0cb411c.png", import.meta.url).toString();

});

parcelRegister("kfWIj", function(module, exports) {
module.exports = new URL("rounded.cc82b2a2.png", import.meta.url).toString();

});

parcelRegister("hVb4G", function(module, exports) {
module.exports = new URL("triangle.7d2a5303.png", import.meta.url).toString();

});

parcelRegister("iR3cc", function(module, exports) {
module.exports = new URL("squiggle.60994818.png", import.meta.url).toString();

});

parcelRegister("hjcJ2", function(module, exports) {
module.exports = new URL("bolt.e9cac636.png", import.meta.url).toString();

});

parcelRegister("daunq", function(module, exports) {
module.exports = new URL("zigzag.a7ed13c7.png", import.meta.url).toString();

});

parcelRegister("6bFdq", function(module, exports) {
module.exports = new URL("fmark.45e7a586.glb", import.meta.url).toString();

});

parcelRegister("3cMrh", function(module, exports) {
module.exports = new URL("fscript.7af7eb37.png", import.meta.url).toString();

});

parcelRegister("eEEyM", function(module, exports) {
module.exports = new URL("fmark.2d8d2ba8.png", import.meta.url).toString();

});

parcelRegister("9yGr6", function(module, exports) {
module.exports = new URL("hippo.121b2bdb.png", import.meta.url).toString();

});



var $gN9y1 = parcelRequire("gN9y1");

var $ilwiq = parcelRequire("ilwiq");

var $7lx9d = parcelRequire("7lx9d");

var $2HSCJ = parcelRequire("2HSCJ");

var $l1cPW = parcelRequire("l1cPW");

var $gFS3f = parcelRequire("gFS3f");

var $9ajTk = parcelRequire("9ajTk");

var $45fwF = parcelRequire("45fwF");

var $hlgjA = parcelRequire("hlgjA");

var $6Lrdv = parcelRequire("6Lrdv");

var $g9ob9 = parcelRequire("g9ob9");
// import { gsap } from "gsap";
// Helper Funcs
function $7c93ed56c9c27f38$var$remap(number, inMin, inMax, outMin, outMax) {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
const $7c93ed56c9c27f38$var$randomInt = (min, max)=>{
    return Math.floor(Math.random() * (max - min) + min);
};
const $7c93ed56c9c27f38$var$randomFloat = (min, max)=>{
    return Math.random() * (max - min) + min;
};
// Objects
const $7c93ed56c9c27f38$var$PARAMS = {
    loaded: false,
    colorSaturation: 0.25,
    mouseReactive: true,
    showInitial: true,
    mode: 0,
    twodeerotate: false,
    twodeeColor1: "#ffffff",
    twodeeColor2: "#ffffff",
    image: 0,
    vapor: false,
    vaporNoiseIntensity: 0.8,
    vaporNoiseVignette: false,
    vaporNoiseAmount: 0.1,
    vaporNoiseType: 0,
    vaporNoiseSpeed: 0.01,
    vaporNoiseScale: 0.1,
    mouseSpeed: 0.2,
    zoom: 0.75,
    grungifyNoise: false,
    grungifyNoiseIntensity: 0.8,
    grungifyNoiseScale: 0.1,
    grungifyNoiseSpeed: 0.1,
    grungifyLineIntensity: 0.01,
    grungifyLines: 100,
    grungifyGlitch: false,
    gltichType: 1,
    glitchSep: 0.0005,
    glitchAngle: 3.1,
    glitchSeed: 0.35,
    glitchSeedX: 0.2,
    glitchSeedY: 0.2,
    glitchDistortionX: 0.5,
    glitchDistortionY: 0.5,
    glitchColumns: 0.01,
    hemiLight: true,
    hemiColor1: 0xB1E1FF,
    hemiColor2: 0xB97A20,
    hemiIntensity: 1,
    dirLight: true,
    dirColor: 0xFFFFFF,
    dirIntensity: 1,
    speed: 0.15,
    shape: 0,
    patternColor1: "#ffffff",
    patternColor2: "#ffffff",
    columns: 25,
    rows: 25,
    wide: 0.75,
    tall: 0.75,
    amp: 0.02,
    freq: 0.02,
    scale: 0.05,
    rainbow: false,
    regular: true,
    sticky: false,
    explosion: false,
    bigWarp: false,
    sobel: false,
    bloom: false,
    bloomStrength: 0.6,
    bloomRadius: 1,
    bloomThreshold: 0.6,
    rgbShift: false,
    rgbShiftAmount: 0.01,
    rgbShiftAngle: 0.2,
    bgColor: "#1C1C1C",
    showBgColor: false
};
const $7c93ed56c9c27f38$var$custom3DUniforms = {
    uTime: {
        value: 0
    },
    uNoise: {
        value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0
    },
    uNoiseIntensity: {
        value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity
    },
    uNoiseScale: {
        value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20)
    },
    uNoiseSpeed: {
        value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10)
    },
    uLineIntensity: {
        value: $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity
    },
    uLines: {
        value: $7c93ed56c9c27f38$var$PARAMS.grungifyLines
    }
};
const $7c93ed56c9c27f38$var$SIZES = {
    width: window.innerWidth,
    height: window.innerHeight
};
const $7c93ed56c9c27f38$var$MOUSE_POS = {
    currentX: 0,
    currentY: 0,
    targetX: 0,
    targetY: 0
};
const $7c93ed56c9c27f38$var$PIXEL_RATIO = Math.min(window.devicePixelRatio, 2);
const $7c93ed56c9c27f38$var$tpContainer = document.querySelector(".pane");
const $7c93ed56c9c27f38$var$pane = new (0, $gN9y1.Pane)({
    title: "Thrash Settings",
    container: $7c93ed56c9c27f38$var$tpContainer
});
$7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "mode", {
    options: {
        twodee: 0,
        threedee: 1,
        pattern: 2
    }
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$twoFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode != 0;
    $7c93ed56c9c27f38$var$threeFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode != 1;
    $7c93ed56c9c27f38$var$gridFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode != 2;
    $7c93ed56c9c27f38$var$updateExperiment();
    $7c93ed56c9c27f38$var$pane.refresh();
});
$7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "showBgColor", {
    label: "bg color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$bgColorPane.hidden = !$7c93ed56c9c27f38$var$PARAMS.showBgColor;
    $7c93ed56c9c27f38$var$renderer.setClearAlpha($7c93ed56c9c27f38$var$PARAMS.showBgColor ? 1 : 0);
});
const $7c93ed56c9c27f38$var$bgColorPane = $7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "bgColor").on("change", ()=>{
    $7c93ed56c9c27f38$var$renderer.setClearColor(new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.bgColor));
});
$7c93ed56c9c27f38$var$bgColorPane.hidden = true;
$7c93ed56c9c27f38$var$pane.expanded = false;
// Tweaks Vapor
$7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "vapor").on("change", ()=>{
    $7c93ed56c9c27f38$var$vaporFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.vapor;
});
const $7c93ed56c9c27f38$var$vaporFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "Vapor Tweaks"
});
$7c93ed56c9c27f38$var$vaporFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.vapor;
const $7c93ed56c9c27f38$var$vBtn = $7c93ed56c9c27f38$var$vaporFolder.addButton({
    title: "randomize!",
    label: "vapor"
});
$7c93ed56c9c27f38$var$vBtn.on("click", ()=>{
    $7c93ed56c9c27f38$var$PARAMS.showInitial = Math.random() < 0.5;
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType = $7c93ed56c9c27f38$var$randomInt(0, 6);
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNType.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType;
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity, 0, 1, 0.5, 1);
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette = Math.random() < 0.5;
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uVignette.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette ? 1 : 0;
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount, 0, 1, 0.1, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 100 : 25);
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale, 0, 1, 0.002, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 0.5 : 0.1);
    $7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed = Math.random() / 25;
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed, 0, 1, 0, 20);
    $7c93ed56c9c27f38$var$pane.refresh();
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "showInitial", {
    label: "initial"
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseType", {
    label: "type",
    options: {
        simplex: 0,
        voronoi: 1,
        "vorn\xfc_1": 2,
        "vorn\xfc_2": 3,
        "vorn\xfc_3": 4
    }
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNType.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType;
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount, 0, 1, 0.1, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 100 : 25);
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale, 0, 1, 0.002, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 0.5 : 0.1);
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseIntensity", {
    label: "intensity",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity, 0, 1, 0.5, 1);
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseVignette", {
    label: "vignette"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uVignette.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette ? 1 : 0;
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseAmount", {
    label: "amount",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount, 0, 1, 0.1, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 100 : 25);
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseScale", {
    label: "scale",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale, 0, 1, 0.002, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 0.5 : 0.1);
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "vaporNoiseSpeed", {
    label: "speed",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed, 0, 1, 0, 20);
});
$7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "mouseReactive", {
    label: "mouse"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$mouseBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.mouseReactive;
    $7c93ed56c9c27f38$var$pane.refresh();
});
const $7c93ed56c9c27f38$var$mouseBlade = $7c93ed56c9c27f38$var$vaporFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "mouseSpeed", {
    step: 0.01,
    min: 0,
    max: 1
});
$7c93ed56c9c27f38$var$mouseBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.mouseReactive;
// Tweaks Noise
$7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyNoise", {
    label: "noise"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$grunfigyNoiseFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.grungifyNoise;
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0;
    $7c93ed56c9c27f38$var$custom3DUniforms.uNoise.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0;
    $7c93ed56c9c27f38$var$pane.refresh();
});
const $7c93ed56c9c27f38$var$grunfigyNoiseFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "Noise Tweaks"
});
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.grungifyNoise;
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyNoiseIntensity", {
    label: "intensity",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity;
    $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity;
});
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyNoiseScale", {
    label: "scale",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20);
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20);
    $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20);
});
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyNoiseSpeed", {
    label: "speed",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10);
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10);
    $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10);
});
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyLines", {
    label: "lines",
    step: 1,
    min: 0,
    max: 4096
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uLines.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLines;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uLines.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLines;
    $7c93ed56c9c27f38$var$custom3DUniforms.uLines.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLines;
});
$7c93ed56c9c27f38$var$grunfigyNoiseFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyLineIntensity", {
    label: "linetensity",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uLineIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uLineIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity;
    $7c93ed56c9c27f38$var$custom3DUniforms.uLineIntensity.value = $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity;
});
// Tweaks Glitch
$7c93ed56c9c27f38$var$pane.addInput($7c93ed56c9c27f38$var$PARAMS, "grungifyGlitch", {
    label: "glitch"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$grunfigyGlitchFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.grungifyGlitch;
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGlitch.value = $7c93ed56c9c27f38$var$PARAMS.grungifyGlitch ? 1.0 : 0.0;
    $7c93ed56c9c27f38$var$pane.refresh();
});
const $7c93ed56c9c27f38$var$grunfigyGlitchFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "Glitch Tweaks"
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.grungifyGlitch;
const $7c93ed56c9c27f38$var$dbtn = $7c93ed56c9c27f38$var$grunfigyGlitchFolder.addButton({
    title: "randomize!",
    label: "glitch"
});
$7c93ed56c9c27f38$var$dbtn.on("click", ()=>{
    $7c93ed56c9c27f38$var$PARAMS.gltichType = $7c93ed56c9c27f38$var$randomInt(0, 3);
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGType.value = $7c93ed56c9c27f38$var$PARAMS.gltichType;
    $7c93ed56c9c27f38$var$PARAMS.glitchSep = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGAmount.value = $7c93ed56c9c27f38$var$PARAMS.glitchSep / 50;
    $7c93ed56c9c27f38$var$PARAMS.glitchAngle = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGAngle.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.glitchAngle, 0, 1, -Math.PI, Math.PI);
    $7c93ed56c9c27f38$var$PARAMS.glitchSeed = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeed.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeed;
    $7c93ed56c9c27f38$var$PARAMS.glitchSeedX = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, -1, 1);
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeedX.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeedX;
    $7c93ed56c9c27f38$var$PARAMS.glitchSeedY = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, -1, 1);
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeedY.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeedY;
    $7c93ed56c9c27f38$var$PARAMS.glitchDistortionX = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGlitchionX.value = $7c93ed56c9c27f38$var$PARAMS.glitchDistortionX;
    $7c93ed56c9c27f38$var$PARAMS.glitchDistortionY = Math.random();
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGlitchionY.value = $7c93ed56c9c27f38$var$PARAMS.glitchDistortionY;
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGColumns.value = $7c93ed56c9c27f38$var$PARAMS.glitchColumns;
    $7c93ed56c9c27f38$var$PARAMS.glitchColumns = Math.random();
    $7c93ed56c9c27f38$var$pane.refresh();
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "gltichType", {
    label: "type",
    options: {
        first: 0,
        second: 1,
        third: 2
    }
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGType.value = $7c93ed56c9c27f38$var$PARAMS.gltichType;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchSep", {
    label: "sep",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGAmount.value = $7c93ed56c9c27f38$var$PARAMS.glitchSep / 50;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchAngle", {
    label: "angle",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGAngle.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.glitchAngle, 0, 1, -Math.PI, Math.PI);
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchSeed", {
    label: "seed root",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeed.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeed;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchSeedX", {
    label: "seed x",
    step: 0.01,
    min: -1,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeedX.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeedX;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchSeedY", {
    label: "seed y",
    step: 0.01,
    min: -1,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGSeedY.value = $7c93ed56c9c27f38$var$PARAMS.glitchSeedY;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchDistortionX", {
    label: "x distort",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGlitchionX.value = $7c93ed56c9c27f38$var$PARAMS.glitchDistortionX;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchDistortionY", {
    label: "y distort",
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGlitchionY.value = $7c93ed56c9c27f38$var$PARAMS.glitchDistortionY;
});
$7c93ed56c9c27f38$var$grunfigyGlitchFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "glitchColumns", {
    label: "columns",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fxMaterial.uniforms.uGColumns.value = $7c93ed56c9c27f38$var$PARAMS.glitchColumns;
});
// Tweaks 2D
const $7c93ed56c9c27f38$var$twoFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "2D Tweaks"
});
$7c93ed56c9c27f38$var$twoFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode != 0;
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "image", {
    options: {
        script: 0,
        mark: 1,
        hippo: 2
    }
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$loadImage();
});
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "twodeeColor1", {
    label: "color 1",
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uColor1.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.twodeeColor1);
});
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "twodeeColor2", {
    label: "color 2",
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uColor2.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.twodeeColor2);
});
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "colorSaturation", {
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uSat.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5);
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uSat.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5);
});
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "twodeerotate", {
    label: "rotate"
}).on("change", ()=>{
    gsap.to($7c93ed56c9c27f38$var$textureMesh.rotation, {
        y: 0,
        ease: "power2.inout",
        duration: 0.75
    });
    gsap.to($7c93ed56c9c27f38$var$textureMesh.rotation, {
        x: 0,
        ease: "power2.inout",
        duration: 0.75
    });
});
$7c93ed56c9c27f38$var$twoFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "zoom", {
    step: 0.001,
    min: 0.1,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$renderImageTexture();
});
// Tweaks 3D
const $7c93ed56c9c27f38$var$threeFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "3D Tweaks"
});
$7c93ed56c9c27f38$var$threeFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode == 0;
$7c93ed56c9c27f38$var$threeFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "hemiLight").on("change", ()=>{
    $7c93ed56c9c27f38$var$hemiFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.hemiLight;
    if ($7c93ed56c9c27f38$var$PARAMS.hemiLight) $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkHemiLight);
    else $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$fmarkHemiLight);
});
const $7c93ed56c9c27f38$var$hemiFolder = $7c93ed56c9c27f38$var$threeFolder.addFolder({
    title: "Hemisphere Light Settings"
});
$7c93ed56c9c27f38$var$hemiFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.hemiLight;
$7c93ed56c9c27f38$var$hemiFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "hemiColor1", {
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fmarkHemiLight.color = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.hemiColor1);
});
$7c93ed56c9c27f38$var$hemiFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "hemiColor2", {
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fmarkHemiLight.groundColor = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.hemiColor2);
});
$7c93ed56c9c27f38$var$hemiFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "hemiIntensity", {
    step: 0.001,
    min: 0,
    max: 2
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fmarkHemiLight.intensity = $7c93ed56c9c27f38$var$PARAMS.hemiIntensity;
});
$7c93ed56c9c27f38$var$threeFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "dirLight").on("change", ()=>{
    $7c93ed56c9c27f38$var$dirFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.dirLight;
    if ($7c93ed56c9c27f38$var$PARAMS.dirLight) $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkDirLight);
    else $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$fmarkDirLight);
});
const $7c93ed56c9c27f38$var$dirFolder = $7c93ed56c9c27f38$var$threeFolder.addFolder({
    title: "Directional Light Settings"
});
$7c93ed56c9c27f38$var$dirFolder.hidden = !$7c93ed56c9c27f38$var$PARAMS.dirLight;
$7c93ed56c9c27f38$var$dirFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "dirColor", {
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fmarkDirLight.color = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.dirColor);
});
$7c93ed56c9c27f38$var$dirFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "dirIntensity", {
    step: 0.001,
    min: 0,
    max: 2
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$fmarkDirLight.intensity = $7c93ed56c9c27f38$var$PARAMS.dirIntensity;
});
// Tweaks Pattern
const $7c93ed56c9c27f38$var$gridFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "Pattern Tweaks"
});
$7c93ed56c9c27f38$var$gridFolder.hidden = $7c93ed56c9c27f38$var$PARAMS.mode != 2;
const $7c93ed56c9c27f38$var$pBtn = $7c93ed56c9c27f38$var$gridFolder.addButton({
    title: "randomize!",
    label: "pattern"
});
$7c93ed56c9c27f38$var$pBtn.on("click", ()=>{
    $7c93ed56c9c27f38$var$PARAMS.shape = $7c93ed56c9c27f38$var$randomInt(0, $7c93ed56c9c27f38$var$shapeTextures.length);
    $7c93ed56c9c27f38$var$PARAMS.columns = $7c93ed56c9c27f38$var$randomInt(5, 101);
    $7c93ed56c9c27f38$var$PARAMS.rows = $7c93ed56c9c27f38$var$randomInt(5, 101);
    $7c93ed56c9c27f38$var$PARAMS.wide = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, 0.1, 1);
    $7c93ed56c9c27f38$var$PARAMS.tall = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, 0.1, 1);
    $7c93ed56c9c27f38$var$PARAMS.speed = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, 0.01, 0.5);
    $7c93ed56c9c27f38$var$PARAMS.amp = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, -1, 1);
    $7c93ed56c9c27f38$var$PARAMS.freq = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, -1, 1);
    $7c93ed56c9c27f38$var$PARAMS.scale = Math.random();
    $7c93ed56c9c27f38$var$PARAMS.rainbow = Math.random() <= 0.4;
    const c = Math.floor(Math.random() * 16777215).toString(16);
    $7c93ed56c9c27f38$var$PARAMS.patternColor1 = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor1.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor1);
    $7c93ed56c9c27f38$var$PARAMS.patternColor2 = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor2.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor2);
    $7c93ed56c9c27f38$var$PARAMS.regular = Math.random() <= 0.5;
    $7c93ed56c9c27f38$var$PARAMS.sticky = Math.random() <= 0.5;
    $7c93ed56c9c27f38$var$PARAMS.explosion = $7c93ed56c9c27f38$var$PARAMS.sticky ? 0 : Math.random() <= 0.15;
    $7c93ed56c9c27f38$var$PARAMS.bigWarp = Math.random() <= 0.15;
    $7c93ed56c9c27f38$var$pane.refresh();
    $7c93ed56c9c27f38$var$loadShapeTexture();
    $7c93ed56c9c27f38$var$buildPattern();
});
$7c93ed56c9c27f38$var$gridFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "twodeerotate", {
    label: "rotate"
}).on("change", ()=>{
    gsap.to($7c93ed56c9c27f38$var$patternMesh.rotation, {
        y: 0,
        ease: "power2.inout",
        duration: 0.75
    });
    gsap.to($7c93ed56c9c27f38$var$patternMesh.rotation, {
        x: 0,
        ease: "power2.inout",
        duration: 0.75
    });
});
let $7c93ed56c9c27f38$var$folder = $7c93ed56c9c27f38$var$gridFolder.addFolder({
    title: "Shape"
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "shape", {
    options: {
        square: 0,
        dot: 1,
        rounded: 2,
        triangle: 3,
        squiggle: 4,
        bolt: 5,
        zigzag: 6
    }
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$loadShapeTexture();
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "wide", {
    label: "shape width",
    min: 0,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$buildPattern();
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "tall", {
    label: "shape height",
    min: 0,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$buildPattern();
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "speed", {
    min: 0.01,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uSpeed.value = $7c93ed56c9c27f38$var$PARAMS.speed;
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "freq", {
    min: -1,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uFreq.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.freq, -1, 1, -0.01, 0.01);
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "amp", {
    min: -1,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uAmp.value = $7c93ed56c9c27f38$var$PARAMS.amp;
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "scale", {
    min: 0,
    max: 1,
    step: 0.01
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uScale.value = $7c93ed56c9c27f38$var$PARAMS.scale;
});
$7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "rainbow").on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uBow.value = $7c93ed56c9c27f38$var$PARAMS.rainbow ? 0.0 : 1.0;
    $7c93ed56c9c27f38$var$shapeColor1Blade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
    $7c93ed56c9c27f38$var$shapeColor2Blade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
    $7c93ed56c9c27f38$var$shapeSatBlade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
    $7c93ed56c9c27f38$var$pane.refresh();
});
const $7c93ed56c9c27f38$var$shapeColor1Blade = $7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "patternColor1", {
    label: "color 1",
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor1.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor1);
});
const $7c93ed56c9c27f38$var$shapeColor2Blade = $7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "patternColor2", {
    label: "color 2",
    view: "color"
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor2.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor2);
});
const $7c93ed56c9c27f38$var$shapeSatBlade = $7c93ed56c9c27f38$var$folder.addInput($7c93ed56c9c27f38$var$PARAMS, "colorSaturation", {
    step: 0.01,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.uSat.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5);
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uSat.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5);
});
$7c93ed56c9c27f38$var$shapeColor1Blade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
$7c93ed56c9c27f38$var$shapeColor2Blade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
$7c93ed56c9c27f38$var$shapeSatBlade.hidden = $7c93ed56c9c27f38$var$PARAMS.rainbow;
const $7c93ed56c9c27f38$var$gridOptions = $7c93ed56c9c27f38$var$gridFolder.addFolder({
    title: "Grid"
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "columns", {
    min: 1,
    max: 250,
    step: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$buildPattern();
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "rows", {
    min: 1,
    max: 250,
    step: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$buildPattern();
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "regular").on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uRegular.value = $7c93ed56c9c27f38$var$PARAMS.regular ? 0.0 : 1.0;
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "sticky").on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uSticky.value = $7c93ed56c9c27f38$var$PARAMS.sticky ? 0.0 : 1.0;
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "explosion").on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uExplosion.value = $7c93ed56c9c27f38$var$PARAMS.explosion ? 0.0 : 1.0;
});
$7c93ed56c9c27f38$var$gridOptions.addInput($7c93ed56c9c27f38$var$PARAMS, "bigWarp").on("change", ()=>{
    $7c93ed56c9c27f38$var$patternMaterial.uniforms.uBigWarp.value = $7c93ed56c9c27f38$var$PARAMS.bigWarp ? 0.0 : 1.0;
});
// Tweaks PP
const $7c93ed56c9c27f38$var$ppFolder = $7c93ed56c9c27f38$var$pane.addFolder({
    title: "Postprocessing Effects"
});
$7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "sobel").on("change", ()=>{
    $7c93ed56c9c27f38$var$buildComposition();
});
$7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "bloom").on("change", ()=>{
    $7c93ed56c9c27f38$var$bStrengthBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.bloom;
    $7c93ed56c9c27f38$var$bRadiusBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.bloom;
    $7c93ed56c9c27f38$var$bThreshBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.bloom;
    $7c93ed56c9c27f38$var$pane.refresh();
    $7c93ed56c9c27f38$var$buildComposition();
});
const $7c93ed56c9c27f38$var$bStrengthBlade = $7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "bloomStrength", {
    label: "strength",
    step: 0.001,
    min: 0,
    max: 2
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$bloomEffect.strength = $7c93ed56c9c27f38$var$PARAMS.bloomStrength;
});
$7c93ed56c9c27f38$var$bStrengthBlade.hidden = true;
const $7c93ed56c9c27f38$var$bRadiusBlade = $7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "bloomRadius", {
    label: "radius",
    step: 0.001,
    min: 0,
    max: 2
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$bloomEffect.radius = $7c93ed56c9c27f38$var$PARAMS.bloomRadius;
});
$7c93ed56c9c27f38$var$bRadiusBlade.hidden = true;
const $7c93ed56c9c27f38$var$bThreshBlade = $7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "bloomThreshold", {
    label: "threshold",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$bloomEffect.threshold = $7c93ed56c9c27f38$var$PARAMS.bloomThreshold;
});
$7c93ed56c9c27f38$var$bThreshBlade.hidden = true;
$7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "rgbShift").on("change", ()=>{
    $7c93ed56c9c27f38$var$rgbStrengthBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.rgbShift;
    $7c93ed56c9c27f38$var$rgbAngleBlade.hidden = !$7c93ed56c9c27f38$var$PARAMS.rgbShift;
    $7c93ed56c9c27f38$var$pane.refresh();
    $7c93ed56c9c27f38$var$buildComposition();
});
const $7c93ed56c9c27f38$var$rgbStrengthBlade = $7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "rgbShiftAmount", {
    label: "amount",
    step: 0.001,
    min: 0,
    max: 1
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$rgbShiftEffect.uniforms.amount.value = $7c93ed56c9c27f38$var$PARAMS.rgbShiftAmount;
});
$7c93ed56c9c27f38$var$rgbStrengthBlade.hidden = true;
const $7c93ed56c9c27f38$var$rgbAngleBlade = $7c93ed56c9c27f38$var$ppFolder.addInput($7c93ed56c9c27f38$var$PARAMS, "rgbShiftAngle", {
    label: "angle",
    step: 0.001,
    min: 0,
    max: Math.PI * 2
}).on("change", ()=>{
    $7c93ed56c9c27f38$var$rgbShiftEffect.uniforms.angle.value = $7c93ed56c9c27f38$var$PARAMS.rgbShiftAngle;
});
$7c93ed56c9c27f38$var$rgbAngleBlade.hidden = true;
// Basic Setup
const $7c93ed56c9c27f38$var$canvas = document.querySelector("canvas.webgl");
const $7c93ed56c9c27f38$var$clock = new $ilwiq.Clock();
var $7c93ed56c9c27f38$var$lastElapsed = 0;
const $7c93ed56c9c27f38$var$scene = new $ilwiq.Scene();
// Post processing 
var $7c93ed56c9c27f38$var$bloomEffect, $7c93ed56c9c27f38$var$rgbShiftEffect, $7c93ed56c9c27f38$var$sobelEffect, $7c93ed56c9c27f38$var$isPP;
var $7c93ed56c9c27f38$var$passes = [];
const $7c93ed56c9c27f38$var$buildComposition = ()=>{
    $7c93ed56c9c27f38$var$isPP = false;
    $7c93ed56c9c27f38$var$passes.forEach((pass)=>{
        $7c93ed56c9c27f38$var$ppComposer.removePass(pass);
    });
    $7c93ed56c9c27f38$var$passes = [];
    $7c93ed56c9c27f38$var$ppComposer.reset($7c93ed56c9c27f38$var$ppRenderTarget);
    $7c93ed56c9c27f38$var$passes.forEach((pass)=>{
        $7c93ed56c9c27f38$var$ppComposer.removePass(pass);
    });
    $7c93ed56c9c27f38$var$passes = [];
    $7c93ed56c9c27f38$var$ppComposer.reset($7c93ed56c9c27f38$var$ppRenderTarget);
    var pass = new (0, $gFS3f.ClearPass)();
    $7c93ed56c9c27f38$var$ppComposer.addPass(pass);
    // TODO: Figure out how to get this to work when vapor is turned off 
    pass = new (0, $l1cPW.RenderPass)($7c93ed56c9c27f38$var$fxScene, $7c93ed56c9c27f38$var$camera);
    pass.clear = false;
    $7c93ed56c9c27f38$var$ppComposer.addPass(pass);
    pass = new (0, $l1cPW.RenderPass)($7c93ed56c9c27f38$var$scene, $7c93ed56c9c27f38$var$camera);
    pass.clear = false;
    $7c93ed56c9c27f38$var$ppComposer.addPass(pass);
    if ($7c93ed56c9c27f38$var$PARAMS.sobel) {
        $7c93ed56c9c27f38$var$isPP = true;
        if (!$7c93ed56c9c27f38$var$sobelEffect) {
            $7c93ed56c9c27f38$var$sobelEffect = new (0, $9ajTk.ShaderPass)((0, $6Lrdv.SobelOperatorShader));
            $7c93ed56c9c27f38$var$sobelEffect.uniforms.resolution.value = new $ilwiq.Vector2($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
        }
        $7c93ed56c9c27f38$var$ppComposer.addPass($7c93ed56c9c27f38$var$sobelEffect);
    }
    if ($7c93ed56c9c27f38$var$PARAMS.rgbShift) {
        $7c93ed56c9c27f38$var$isPP = true;
        if (!$7c93ed56c9c27f38$var$rgbShiftEffect) {
            $7c93ed56c9c27f38$var$rgbShiftEffect = new (0, $9ajTk.ShaderPass)((0, $g9ob9.RGBShiftShader));
            $7c93ed56c9c27f38$var$rgbShiftEffect.uniforms.amount.value = $7c93ed56c9c27f38$var$PARAMS.rgbShiftAmount;
            $7c93ed56c9c27f38$var$rgbShiftEffect.uniforms.angle.value = $7c93ed56c9c27f38$var$PARAMS.rgbShiftAngle;
        }
        $7c93ed56c9c27f38$var$ppComposer.addPass($7c93ed56c9c27f38$var$rgbShiftEffect);
    }
    if ($7c93ed56c9c27f38$var$PARAMS.bloom) {
        $7c93ed56c9c27f38$var$isPP = true;
        if (!$7c93ed56c9c27f38$var$bloomEffect) {
            $7c93ed56c9c27f38$var$bloomEffect = new (0, $hlgjA.UnrealBloomPass)();
            $7c93ed56c9c27f38$var$bloomEffect.strength = $7c93ed56c9c27f38$var$PARAMS.bloomStrength;
            $7c93ed56c9c27f38$var$bloomEffect.radius = $7c93ed56c9c27f38$var$PARAMS.bloomRadius;
            $7c93ed56c9c27f38$var$bloomEffect.threshold = $7c93ed56c9c27f38$var$PARAMS.bloomThreshold;
        }
        $7c93ed56c9c27f38$var$ppComposer.addPass($7c93ed56c9c27f38$var$bloomEffect);
    }
    pass = new (0, $9ajTk.ShaderPass)((0, $45fwF.CopyShader));
    $7c93ed56c9c27f38$var$ppComposer.addPass(pass);
};
// Shader Pattern
var $7c93ed56c9c27f38$var$cellSize = 1;
const $7c93ed56c9c27f38$var$pVertexShader = /*glsl*/ `
    #define PI 3.14159265359    
    uniform float uTime;
    uniform float uSpeed;
    uniform float uAmp;
    uniform float uFreq;
    uniform float uScale;
    uniform float uRegular;
    uniform float uSticky;
    uniform float uExplosion;
    uniform float uBigWarp;

    attribute vec3 translate;

    varying vec2 vUv;
    varying float vNoise;

    //	Simplex 3D Noise 
    //	by Ian McEwan, Ashima Arts
    //
    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}

    float snoise(vec3 v){ 
    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

    // First corner
    vec3 i  = floor(v + dot(v, C.yyy) );
    vec3 x0 =   v - i + dot(i, C.xxx) ;

    // Other corners
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min( g.xyz, l.zxy );
    vec3 i2 = max( g.xyz, l.zxy );

    //  x0 = x0 - 0. + 0.0 * C 
    vec3 x1 = x0 - i1 + 1.0 * C.xxx;
    vec3 x2 = x0 - i2 + 2.0 * C.xxx;
    vec3 x3 = x0 - 1. + 3.0 * C.xxx;

    // Permutations
    i = mod(i, 289.0 ); 
    vec4 p = permute( permute( permute( 
                i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
            + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
            + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

    // Gradients
    // ( N*N points uniformly over a square, mapped onto an octahedron.)
    float n_ = 1.0/7.0; // N=7
    vec3  ns = n_ * D.wyz - D.xzx;

    vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)

    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

    vec4 x = x_ *ns.x + ns.yyyy;
    vec4 y = y_ *ns.x + ns.yyyy;
    vec4 h = 1.0 - abs(x) - abs(y);

    vec4 b0 = vec4( x.xy, y.xy );
    vec4 b1 = vec4( x.zw, y.zw );

    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));

    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

    vec3 p0 = vec3(a0.xy,h.x);
    vec3 p1 = vec3(a0.zw,h.y);
    vec3 p2 = vec3(a1.xy,h.z);
    vec3 p3 = vec3(a1.zw,h.w);

    //Normalise gradients
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;

    // Mix final noise value
    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
                                    dot(p2,x2), dot(p3,x3) ) );
    }

    float noise(vec3 tr,float t) {
        vec3 trTime = vec3(tr.x + t,tr.y + t,tr.z + t);
        return sin( trTime.x * 2.1 ) + sin( trTime.y * 3.2 ) + sin( trTime.z * 4.3 );
    }

    vec2 rotate2D(vec2 st, float a) {
        st -= 0.5;
        st = mat2(cos(a),-sin(a),
                  sin(a),cos(a))*st;
        st += 0.5;
        return st;
    }

    float map(float value, float inMin, float inMax, float outMin, float outMax) {
        return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);
    }

    void main()
    {
        vec4 mvPosition = modelViewMatrix * vec4( translate, 1.0 );
        float noise = snoise(vec3((translate.xy*uFreq),uTime*uSpeed));

        //rotate individuals
        vec2 pos = position.xy;
        mvPosition.xy += rotate2D(pos.xy,noise*uAmp*PI); 
        (uBigWarp == 0. ? mvPosition.xy += rotate2D(mvPosition.xy,noise*uAmp*noise*uAmp*20.) : mvPosition.xy += 0.); 

        float scale = map(noise*uScale, 0., 1., 0.1,10.);

        mvPosition.xyz += (uRegular == 0. ? position * scale : position);
        mvPosition.xyz *= (uSticky == 0. ? (step(scale,0.01) < 0.01 ? 0. : step(scale,0.01)) : 1.);
        mvPosition.xyz *= (uExplosion == 0. ? scale : 1.);

        gl_Position = projectionMatrix * mvPosition;
        
        vNoise = noise;
        vUv = uv;
    }
`;
const $7c93ed56c9c27f38$var$pFragmentShader = /*glsl*/ `
    uniform sampler2D uMap;
    uniform vec3 uColor1;
    uniform vec3 uColor2;
    uniform float uBow;
    uniform float uTime;
    uniform float uNoise;
    uniform float uNoiseIntensity;
    uniform float uNoiseSpeed;
    uniform float uNoiseScale;
    uniform float uLineIntensity;
    uniform float uLines;
    uniform float uSat;

    varying vec2 vUv;
    varying float vNoise;

    //	Simplex 3D Noise 
    //	by Ian McEwan, Ashima Arts
    //
    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}

    float snoise(vec3 v){ 
        const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
        const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

        // First corner
        vec3 i  = floor(v + dot(v, C.yyy) );
        vec3 x0 =   v - i + dot(i, C.xxx) ;

        // Other corners
        vec3 g = step(x0.yzx, x0.xyz);
        vec3 l = 1.0 - g;
        vec3 i1 = min( g.xyz, l.zxy );
        vec3 i2 = max( g.xyz, l.zxy );

        //  x0 = x0 - 0. + 0.0 * C 
        vec3 x1 = x0 - i1 + 1.0 * C.xxx;
        vec3 x2 = x0 - i2 + 2.0 * C.xxx;
        vec3 x3 = x0 - 1. + 3.0 * C.xxx;

        // Permutations
        i = mod(i, 289.0 ); 
        vec4 p = permute( permute( permute( 
                    i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
                + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
                + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

        // Gradients
        // ( N*N points uniformly over a square, mapped onto an octahedron.)
        float n_ = 1.0/7.0; // N=7
        vec3  ns = n_ * D.wyz - D.xzx;

        vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)

        vec4 x_ = floor(j * ns.z);
        vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

        vec4 x = x_ *ns.x + ns.yyyy;
        vec4 y = y_ *ns.x + ns.yyyy;
        vec4 h = 1.0 - abs(x) - abs(y);

        vec4 b0 = vec4( x.xy, y.xy );
        vec4 b1 = vec4( x.zw, y.zw );

        vec4 s0 = floor(b0)*2.0 + 1.0;
        vec4 s1 = floor(b1)*2.0 + 1.0;
        vec4 sh = -step(h, vec4(0.0));

        vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
        vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

        vec3 p0 = vec3(a0.xy,h.x);
        vec3 p1 = vec3(a0.zw,h.y);
        vec3 p2 = vec3(a1.xy,h.z);
        vec3 p3 = vec3(a1.zw,h.w);

        //Normalise gradients
        vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
        p0 *= norm.x;
        p1 *= norm.y;
        p2 *= norm.z;
        p3 *= norm.w;

        // Mix final noise value
        vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
        m = m * m;
        return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
                                        dot(p2,x2), dot(p3,x3) ) );
    }

    vec3 adjustSaturation(vec3 color, float value) {
        // https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
        const vec3 luminosityFactor = vec3(0.2126, 0.7152, 0.0722);
        vec3 grayscale = vec3(dot(color, luminosityFactor));

        return mix(grayscale, color, 1.0 + value);
    }

    // HSL to RGB Convertion helpers
    vec3 HUEtoRGB(float H){
        H = mod(H,1.0);
        float R = abs(H * 6.0 - 3.0) - 1.0;
        float G = 2.0 - abs(H * 6.0 - 2.0);
        float B = 2.0 - abs(H * 6.0 - 4.0);
        return clamp(vec3(R,G,B),0.0,1.0);
    }

    vec3 HSLtoRGB(vec3 HSL){
        vec3 RGB = HUEtoRGB(HSL.x);
        float C = (1.0 - abs(2.0 * HSL.z - 1.0)) * HSL.y;
        return (RGB - 0.5) * C + HSL.z;
    }

    void main() {
        vec4 diffuseColor = texture2D( uMap, vUv );
        if (diffuseColor.a < 0.9) {
            discard;
        } else {
            vec3 color = (uBow != 1. ? HSLtoRGB(vec3(vNoise/2.5, 1.0, 0.5)) : vec3(mix(uColor1,uColor2,1.-vUv.y)));
            if(uNoise == 1.){
                // make some noise
                vec2 uv = gl_FragCoord.xy;
                uv /= uNoiseScale;
                float n = snoise(vec3(uv, uTime * uNoiseSpeed));
                // add noise
                vec3 colorNoise = vec3(n * 0.5 + 0.5);
                color *= mix(colorNoise * uNoiseIntensity * 2., color, 1. - uNoiseIntensity);
                // get us a sine and cosine
                vec2 sc = vec2( sin( vUv.y * uLines ), cos( vUv.y * uLines ) );
                // add scanlines
                color += color * vec3( sc.x, sc.y, sc.x ) * uLineIntensity;
            }
            color = adjustSaturation(color, uSat);
            gl_FragColor =  vec4(diffuseColor.xyz * color, diffuseColor.w);
        }
    }
`;
const $7c93ed56c9c27f38$var$patternMaterial = new $ilwiq.ShaderMaterial({
    vertexShader: $7c93ed56c9c27f38$var$pVertexShader,
    fragmentShader: $7c93ed56c9c27f38$var$pFragmentShader,
    transparent: true,
    uniforms: {
        "uMap": {
            value: null
        },
        "uTime": {
            value: 0.0
        },
        "uSpeed": {
            value: 1.0
        },
        "uColor1": {
            value: new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor1)
        },
        "uColor2": {
            value: new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor2)
        },
        "uBow": {
            value: $7c93ed56c9c27f38$var$PARAMS.rainbow ? 0.0 : 1.0
        },
        "uAmp": {
            value: $7c93ed56c9c27f38$var$PARAMS.amp
        },
        "uFreq": {
            value: $7c93ed56c9c27f38$var$PARAMS.freq
        },
        "uScale": {
            value: $7c93ed56c9c27f38$var$PARAMS.scale
        },
        "uRegular": {
            value: $7c93ed56c9c27f38$var$PARAMS.regular ? 0.0 : 1.0
        },
        "uSticky": {
            value: $7c93ed56c9c27f38$var$PARAMS.sticky ? 0.0 : 1.0
        },
        "uExplosion": {
            value: $7c93ed56c9c27f38$var$PARAMS.explosion ? 0.0 : 1.0
        },
        "uBigWarp": {
            value: $7c93ed56c9c27f38$var$PARAMS.bigWarp ? 0.0 : 1.0
        },
        "uTime": {
            value: 0
        },
        "uNoise": {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0
        },
        "uNoiseIntensity": {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity
        },
        "uNoiseScale": {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20)
        },
        "uNoiseSpeed": {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10)
        },
        "uLineIntensity": {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity
        },
        "uLines": {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyLines
        },
        "uSat": {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5)
        }
    }
});
const $7c93ed56c9c27f38$var$textureLoader = new $ilwiq.TextureLoader();
var $7c93ed56c9c27f38$var$patternMesh, $7c93ed56c9c27f38$var$patternTexture;







const $7c93ed56c9c27f38$var$shapeTextures = [
    new URL((parcelRequire("h73Jq"))),
    new URL((parcelRequire("edFGq"))),
    new URL((parcelRequire("kfWIj"))),
    new URL((parcelRequire("hVb4G"))),
    new URL((parcelRequire("iR3cc"))),
    new URL((parcelRequire("hjcJ2"))),
    new URL((parcelRequire("daunq")))
];
const $7c93ed56c9c27f38$var$loadShapeTexture = ()=>{
    $7c93ed56c9c27f38$var$textureLoader.load($7c93ed56c9c27f38$var$shapeTextures[$7c93ed56c9c27f38$var$PARAMS.shape], function(tex) {
        $7c93ed56c9c27f38$var$patternMaterial.uniforms.uMap.value = tex;
        if ($7c93ed56c9c27f38$var$patternTexture) $7c93ed56c9c27f38$var$patternTexture.dispose();
        $7c93ed56c9c27f38$var$patternTexture = tex;
    });
};
const $7c93ed56c9c27f38$var$buildPattern = ()=>{
    $7c93ed56c9c27f38$var$hidePattern();
    /**
     * Geometry and mesh
     */ const dimension = Math.max($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
    const w = dimension / $7c93ed56c9c27f38$var$PARAMS.columns;
    const padw = w * (1 - $7c93ed56c9c27f38$var$PARAMS.wide);
    const h = dimension / $7c93ed56c9c27f38$var$PARAMS.rows;
    const padh = h * (1 - $7c93ed56c9c27f38$var$PARAMS.tall);
    const gw = w - padw;
    const gh = h - padh;
    $7c93ed56c9c27f38$var$cellSize = Math.max(w, h);
    const geom = new $ilwiq.PlaneGeometry(gw, gh);
    const geometry = new $ilwiq.InstancedBufferGeometry();
    geometry.index = geom.index;
    geometry.attributes = geom.attributes;
    const particleCount = $7c93ed56c9c27f38$var$PARAMS.columns * $7c93ed56c9c27f38$var$PARAMS.rows;
    const translateArray = new Float32Array(particleCount * 3);
    for(let i = 0, i3 = 0; i < particleCount; i++, i3 += 3)if ($7c93ed56c9c27f38$var$PARAMS.threedee) {
        translateArray[i3 + 0] = (Math.random() * 2 - 1) * dimension;
        translateArray[i3 + 1] = (Math.random() * 2 - 1) * dimension;
        translateArray[i3 + 2] = (Math.random() * 2 - 1) * dimension;
    } else {
        const col = i % $7c93ed56c9c27f38$var$PARAMS.columns;
        const row = Math.floor(i / $7c93ed56c9c27f38$var$PARAMS.columns);
        const x = col * w + w - (dimension * 0.5 + w * 0.5);
        const y = row * h + h - (dimension * 0.5 + h * 0.5);
        translateArray[i3 + 0] = x;
        translateArray[i3 + 1] = y;
        translateArray[i3 + 2] = 0;
    }
    if (!$7c93ed56c9c27f38$var$patternMesh) $7c93ed56c9c27f38$var$patternMesh = new $ilwiq.Mesh(geometry, $7c93ed56c9c27f38$var$patternMaterial);
    else $7c93ed56c9c27f38$var$patternMesh.geometry = geometry;
    $7c93ed56c9c27f38$var$patternMesh.rotation.x = 0;
    $7c93ed56c9c27f38$var$patternMesh.rotation.y = 0;
    $7c93ed56c9c27f38$var$patternMesh.geometry.setAttribute("translate", new $ilwiq.InstancedBufferAttribute(translateArray, 3));
    $7c93ed56c9c27f38$var$patternMesh.geometry.needsUpdate = true;
    $7c93ed56c9c27f38$var$patternMaterial.needsUpdate = true;
    $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$patternMesh);
};
const $7c93ed56c9c27f38$var$loadPattern = ()=>{
    if (!$7c93ed56c9c27f38$var$patternMesh) {
        $7c93ed56c9c27f38$var$loadShapeTexture();
        $7c93ed56c9c27f38$var$buildPattern();
    } else $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$patternMesh);
};
const $7c93ed56c9c27f38$var$hidePattern = ()=>{
    if (!$7c93ed56c9c27f38$var$patternMesh) return;
    $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$patternMesh);
};
// Shader 3D
const $7c93ed56c9c27f38$var$modelVertexShader = /*glsl*/ `
varying vec2 v_uv;
    void main () {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        v_uv = uv;
    }
`;
const $7c93ed56c9c27f38$var$modelFragmentShader = /*glsl*/ `
    uniform vec3 uColor1;
    uniform vec3 uColor2;
    uniform float uTime;
    varying vec2 v_uv;

    float wave(vec2 p, float angle) {
    vec2 direction = vec2(cos(angle), sin(angle));
    return cos(dot(p, direction));
    }

    float wrap(float x) {
    return abs(mod(x, 2.)-1.);
    }

    void main () {
        vec2 p = (v_uv - 0.5) * 50.;

        float brightness = 0.;
        for (float i = 1.; i <= 11.; i++) {
        brightness += wave(p, uTime / i);
        }

        brightness = wrap(brightness);

        gl_FragColor = vec4(mix(uColor1,uColor2,brightness),1.);
    }
`;
const $7c93ed56c9c27f38$var$gltfLoader = new (0, $7lx9d.GLTFLoader)();
let $7c93ed56c9c27f38$var$fmarkMesh, $7c93ed56c9c27f38$var$fmarkHemiLight, $7c93ed56c9c27f38$var$fmarkDirLight, $7c93ed56c9c27f38$var$fmarkMaterial;

const $7c93ed56c9c27f38$var$loadModel = ()=>{
    if (!$7c93ed56c9c27f38$var$fmarkMesh) {
        $7c93ed56c9c27f38$var$PARAMS.loaded = false;
        $7c93ed56c9c27f38$var$gltfLoader.load(new URL((parcelRequire("6bFdq"))).href, (gltf)=>{
            $7c93ed56c9c27f38$var$fmarkMesh = gltf.scene.children[0];
            $7c93ed56c9c27f38$var$fmarkMesh.geometry.scale(250, 250, 500);
            // fmarkMaterial = new THREE.ShaderMaterial({
            //     uniforms: {
            //         uTime: { value: 0 },
            //         uColor1: { value: new THREE.Vector3(1, 0, 0) },
            //         uColor2: { value: new THREE.Vector3(1, 1, 0) }
            //     },
            //     vertexShader: modelVertexShader,
            //     fragmentShader: modelFragmentShader
            // });
            $7c93ed56c9c27f38$var$fmarkMaterial = new $ilwiq.MeshPhongMaterial({
                color: "#8AC"
            });
            $7c93ed56c9c27f38$var$fmarkMaterial.onBeforeCompile = (shader)=>{
                shader.uniforms.uTime = $7c93ed56c9c27f38$var$custom3DUniforms.uTime;
                shader.uniforms.uNoise = $7c93ed56c9c27f38$var$custom3DUniforms.uNoise;
                shader.uniforms.uNoiseIntensity = $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseIntensity;
                shader.uniforms.uNoiseSpeed = $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseSpeed;
                shader.uniforms.uNoiseScale = $7c93ed56c9c27f38$var$custom3DUniforms.uNoiseScale;
                shader.uniforms.uLineIntensity = $7c93ed56c9c27f38$var$custom3DUniforms.uLineIntensity;
                shader.uniforms.uLines = $7c93ed56c9c27f38$var$custom3DUniforms.uLines;
                shader.fragmentShader = shader.fragmentShader.replace("uniform float opacity;", `
                            uniform float opacity;
                            uniform float uTime;
                            uniform float uNoise;
                            uniform float uNoiseIntensity;
                            uniform float uNoiseSpeed;
                            uniform float uNoiseScale;
                            uniform float uLineIntensity;
                            uniform float uLines;

                            //	Simplex 3D Noise 
                            //	by Ian McEwan, Ashima Arts
                            //
                            vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
                            vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}

                            float snoise(vec3 v){ 
                                const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
                                const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

                                // First corner
                                vec3 i  = floor(v + dot(v, C.yyy) );
                                vec3 x0 =   v - i + dot(i, C.xxx) ;

                                // Other corners
                                vec3 g = step(x0.yzx, x0.xyz);
                                vec3 l = 1.0 - g;
                                vec3 i1 = min( g.xyz, l.zxy );
                                vec3 i2 = max( g.xyz, l.zxy );

                                //  x0 = x0 - 0. + 0.0 * C 
                                vec3 x1 = x0 - i1 + 1.0 * C.xxx;
                                vec3 x2 = x0 - i2 + 2.0 * C.xxx;
                                vec3 x3 = x0 - 1. + 3.0 * C.xxx;

                                // Permutations
                                i = mod(i, 289.0 ); 
                                vec4 p = permute( permute( permute( 
                                            i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
                                        + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
                                        + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

                                // Gradients
                                // ( N*N points uniformly over a square, mapped onto an octahedron.)
                                float n_ = 1.0/7.0; // N=7
                                vec3  ns = n_ * D.wyz - D.xzx;

                                vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)

                                vec4 x_ = floor(j * ns.z);
                                vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

                                vec4 x = x_ *ns.x + ns.yyyy;
                                vec4 y = y_ *ns.x + ns.yyyy;
                                vec4 h = 1.0 - abs(x) - abs(y);

                                vec4 b0 = vec4( x.xy, y.xy );
                                vec4 b1 = vec4( x.zw, y.zw );

                                vec4 s0 = floor(b0)*2.0 + 1.0;
                                vec4 s1 = floor(b1)*2.0 + 1.0;
                                vec4 sh = -step(h, vec4(0.0));

                                vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
                                vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

                                vec3 p0 = vec3(a0.xy,h.x);
                                vec3 p1 = vec3(a0.zw,h.y);
                                vec3 p2 = vec3(a1.xy,h.z);
                                vec3 p3 = vec3(a1.zw,h.w);

                                //Normalise gradients
                                vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
                                p0 *= norm.x;
                                p1 *= norm.y;
                                p2 *= norm.z;
                                p3 *= norm.w;

                                // Mix final noise value
                                vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
                                m = m * m;
                                return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
                                                                dot(p2,x2), dot(p3,x3) ) );
                            }
                        `);
                shader.fragmentShader = shader.fragmentShader.replace("vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;", `
                            vec3 color = vec3(1.);
                            if(uNoise == 1.){
                                // make some noise
                                vec2 uv = gl_FragCoord.xy;
                                uv /= uNoiseScale;
                                float n = snoise(vec3(uv, uTime * uNoiseSpeed));
                                // add noise
                                vec3 colorNoise = vec3(n * 0.5 + 0.5);
                                color = mix(colorNoise * uNoiseIntensity * 2., color, 1. - uNoiseIntensity);
                                // get us a sine and cosine
                                vec2 sc = vec2( sin( uv.y * uLines ), cos( uv.y * uLines ) );
                                // add scanlines
                                color += color * vec3( sc.x, sc.y, sc.x ) * uLineIntensity;
                            }
                            vec3 outgoingLight = (reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance) * color;
                        `);
            };
            $7c93ed56c9c27f38$var$fmarkMesh.material = $7c93ed56c9c27f38$var$fmarkMaterial;
            $7c93ed56c9c27f38$var$fmarkMesh.castShadow = true;
            $7c93ed56c9c27f38$var$fmarkMesh.receiveShadow = true;
            $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkMesh);
            $7c93ed56c9c27f38$var$fmarkHemiLight = new $ilwiq.HemisphereLight($7c93ed56c9c27f38$var$PARAMS.hemiColor1, $7c93ed56c9c27f38$var$PARAMS.hemiColor2, $7c93ed56c9c27f38$var$PARAMS.hemiIntensity);
            $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkHemiLight);
            $7c93ed56c9c27f38$var$fmarkDirLight = new $ilwiq.DirectionalLight($7c93ed56c9c27f38$var$PARAMS.dirColor, $7c93ed56c9c27f38$var$PARAMS.dirIntensity);
            $7c93ed56c9c27f38$var$fmarkDirLight.position.set(50, 200, 100);
            $7c93ed56c9c27f38$var$fmarkDirLight.target.position.set(0, 0, 0);
            $7c93ed56c9c27f38$var$fmarkDirLight.castShadow = true;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.mapSize.width = 1024;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.mapSize.height = 1024;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.near = 0.5;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.far = 500;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.left = -250;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.right = 250;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.top = 250;
            $7c93ed56c9c27f38$var$fmarkDirLight.shadow.camera.bottom = -250;
            $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkDirLight);
            $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkDirLight.target);
            $7c93ed56c9c27f38$var$PARAMS.loaded = true;
        });
    } else {
        $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkMesh);
        $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkHemiLight);
        $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$fmarkDirLight);
    }
};
const $7c93ed56c9c27f38$var$hideModel = ()=>{
    if (!$7c93ed56c9c27f38$var$fmarkMesh) return;
    $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$fmarkMesh);
    $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$fmarkHemiLight);
    $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$fmarkDirLight);
};
// Image Texture
const $7c93ed56c9c27f38$var$textureCanvas = document.createElement("canvas");
$7c93ed56c9c27f38$var$textureCanvas.width = $7c93ed56c9c27f38$var$SIZES.width;
$7c93ed56c9c27f38$var$textureCanvas.height = $7c93ed56c9c27f38$var$SIZES.height;
const $7c93ed56c9c27f38$var$ctx = $7c93ed56c9c27f38$var$textureCanvas.getContext("2d");
var $7c93ed56c9c27f38$var$textureImg = new Image();
$7c93ed56c9c27f38$var$textureImg.onload = function() {
    $7c93ed56c9c27f38$var$scene.add($7c93ed56c9c27f38$var$textureMesh);
    $7c93ed56c9c27f38$var$renderImageTexture();
    $7c93ed56c9c27f38$var$PARAMS.loaded = true;
};



const $7c93ed56c9c27f38$var$svgUrls = [
    new URL((parcelRequire("3cMrh"))),
    new URL((parcelRequire("eEEyM"))),
    new URL((parcelRequire("9yGr6")))
];
const $7c93ed56c9c27f38$var$loadImage = ()=>{
    $7c93ed56c9c27f38$var$PARAMS.loaded = false;
    $7c93ed56c9c27f38$var$textureImg.src = $7c93ed56c9c27f38$var$svgUrls[$7c93ed56c9c27f38$var$PARAMS.image];
};
const $7c93ed56c9c27f38$var$hideImage = ()=>{
    if (!$7c93ed56c9c27f38$var$textureMesh) return;
    $7c93ed56c9c27f38$var$scene.remove($7c93ed56c9c27f38$var$textureMesh);
};
const $7c93ed56c9c27f38$var$updateExperiment = ()=>{
    if ($7c93ed56c9c27f38$var$PARAMS.mode == 0) {
        $7c93ed56c9c27f38$var$loadImage();
        $7c93ed56c9c27f38$var$hideModel();
        $7c93ed56c9c27f38$var$hidePattern();
    } else if ($7c93ed56c9c27f38$var$PARAMS.mode == 1) {
        $7c93ed56c9c27f38$var$hideImage();
        $7c93ed56c9c27f38$var$loadModel();
        $7c93ed56c9c27f38$var$hidePattern();
    } else {
        $7c93ed56c9c27f38$var$hideImage();
        $7c93ed56c9c27f38$var$hideModel();
        $7c93ed56c9c27f38$var$loadPattern();
    }
    $7c93ed56c9c27f38$var$buildComposition();
};
const $7c93ed56c9c27f38$var$overrideExperiment = (option = 0)=>{
    // TODO: Add other otions
    // square: 0,
    // dot: 1,
    // rounded: 2,
    // triangle: 3,
    // squiggle: 4,
    // bolt: 5,
    // zigzag: 6
    $7c93ed56c9c27f38$var$PARAMS.mode = 2;
    switch(option){
        case 0:
            $7c93ed56c9c27f38$var$PARAMS.vapor = true;
            $7c93ed56c9c27f38$var$PARAMS.mouseReactive = false;
            $7c93ed56c9c27f38$var$PARAMS.showInitial = false;
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType = 4;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNType.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType;
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity = 0.75;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseIntensity.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity, 0, 1, 0.5, 1);
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette = false;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uVignette.value = $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette ? 1 : 0;
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount = 0.9;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoise.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount, 0, 1, 0.1, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 100 : 25);
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale = 0.006;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseScale.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale, 0, 1, 0.002, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 0.5 : 0.1);
            $7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed = 0.001;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uNoiseSpeed.value = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed, 0, 1, 0, 20);
            $7c93ed56c9c27f38$var$PARAMS.shape = 0;
            $7c93ed56c9c27f38$var$PARAMS.columns = 98;
            $7c93ed56c9c27f38$var$PARAMS.rows = 13;
            $7c93ed56c9c27f38$var$PARAMS.wide = 0.32;
            $7c93ed56c9c27f38$var$PARAMS.tall = 0.26;
            $7c93ed56c9c27f38$var$PARAMS.speed = 0.02;
            $7c93ed56c9c27f38$var$PARAMS.amp = 0.86;
            $7c93ed56c9c27f38$var$PARAMS.freq = -1;
            $7c93ed56c9c27f38$var$PARAMS.scale = 0.88;
            $7c93ed56c9c27f38$var$PARAMS.rainbow = false;
            $7c93ed56c9c27f38$var$PARAMS.patternColor1 = "#80868D";
            $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor1.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor1);
            $7c93ed56c9c27f38$var$PARAMS.patternColor2 = "#49897A";
            $7c93ed56c9c27f38$var$patternMaterial.uniforms.uColor2.value = new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.patternColor2);
            $7c93ed56c9c27f38$var$PARAMS.regular = true;
            $7c93ed56c9c27f38$var$PARAMS.sticky = true;
            $7c93ed56c9c27f38$var$PARAMS.explosion = false;
            $7c93ed56c9c27f38$var$PARAMS.bigWarp = false;
            break;
        default:
            break;
    }
    $7c93ed56c9c27f38$var$pane.refresh();
    $7c93ed56c9c27f38$var$updateExperiment();
};
// Shader Image
const $7c93ed56c9c27f38$var$texVertexShader = /*glsl*/ `
    varying vec2 vUv;

    void main () {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        vUv = uv;
    }
`;
const $7c93ed56c9c27f38$var$texFragmentShader = /*glsl*/ `
    uniform sampler2D sampler;
    uniform float uTime;
    uniform float uNoise;
    uniform float uNoiseIntensity;
    uniform float uNoiseSpeed;
    uniform float uNoiseScale;
    uniform float uLineIntensity;
    uniform float uLines;
    uniform vec3 uColor1;
    uniform vec3 uColor2;
    uniform float uSat;
    varying vec2 vUv;

    //	Simplex 3D Noise 
    //	by Ian McEwan, Ashima Arts
    //
    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}

    float snoise(vec3 v){ 
        const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
        const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

        // First corner
        vec3 i  = floor(v + dot(v, C.yyy) );
        vec3 x0 =   v - i + dot(i, C.xxx) ;

        // Other corners
        vec3 g = step(x0.yzx, x0.xyz);
        vec3 l = 1.0 - g;
        vec3 i1 = min( g.xyz, l.zxy );
        vec3 i2 = max( g.xyz, l.zxy );

        //  x0 = x0 - 0. + 0.0 * C 
        vec3 x1 = x0 - i1 + 1.0 * C.xxx;
        vec3 x2 = x0 - i2 + 2.0 * C.xxx;
        vec3 x3 = x0 - 1. + 3.0 * C.xxx;

        // Permutations
        i = mod(i, 289.0 ); 
        vec4 p = permute( permute( permute( 
                    i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
                + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
                + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

        // Gradients
        // ( N*N points uniformly over a square, mapped onto an octahedron.)
        float n_ = 1.0/7.0; // N=7
        vec3  ns = n_ * D.wyz - D.xzx;

        vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)

        vec4 x_ = floor(j * ns.z);
        vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

        vec4 x = x_ *ns.x + ns.yyyy;
        vec4 y = y_ *ns.x + ns.yyyy;
        vec4 h = 1.0 - abs(x) - abs(y);

        vec4 b0 = vec4( x.xy, y.xy );
        vec4 b1 = vec4( x.zw, y.zw );

        vec4 s0 = floor(b0)*2.0 + 1.0;
        vec4 s1 = floor(b1)*2.0 + 1.0;
        vec4 sh = -step(h, vec4(0.0));

        vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
        vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

        vec3 p0 = vec3(a0.xy,h.x);
        vec3 p1 = vec3(a0.zw,h.y);
        vec3 p2 = vec3(a1.xy,h.z);
        vec3 p3 = vec3(a1.zw,h.w);

        //Normalise gradients
        vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
        p0 *= norm.x;
        p1 *= norm.y;
        p2 *= norm.z;
        p3 *= norm.w;

        // Mix final noise value
        vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
        m = m * m;
        return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
                                        dot(p2,x2), dot(p3,x3) ) );
    }

    vec3 adjustSaturation(vec3 color, float value) {
        // https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
        const vec3 luminosityFactor = vec3(0.2126, 0.7152, 0.0722);
        vec3 grayscale = vec3(dot(color, luminosityFactor));

        return mix(grayscale, color, 1.0 + value);
    }

    void main () {
        vec4 texColor = texture2D(sampler, vUv);
        if (texColor.a < 0.9) {
            discard;
        } else {
            vec3 color = vec3(mix(uColor1,uColor2,1.-vUv.y));
            if(uNoise == 1.){
                // make some noise
                vec2 uv = gl_FragCoord.xy;
                uv /= uNoiseScale;
                float n = snoise(vec3(uv, uTime * uNoiseSpeed));
                // add noise
                vec3 colorNoise = vec3(n * 0.5 + 0.5);
                color *= mix(colorNoise * uNoiseIntensity * 2., color, 1. - uNoiseIntensity);
                // get us a sine and cosine
                vec2 sc = vec2( sin( vUv.y * uLines ), cos( vUv.y * uLines ) );
                // add scanlines
                color += color * vec3( sc.x, sc.y, sc.x ) * uLineIntensity;
            }
            color = adjustSaturation(color, uSat);
            gl_FragColor =  vec4(color, texColor.a);

        }
    }
`;
const $7c93ed56c9c27f38$var$textureGeometry = new $ilwiq.PlaneGeometry($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
const $7c93ed56c9c27f38$var$textureMaterial = new $ilwiq.ShaderMaterial({
    uniforms: {
        sampler: {
            value: null
        },
        uTime: {
            value: 0
        },
        uNoise: {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoise ? 1.0 : 0.0
        },
        uNoiseIntensity: {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyNoiseIntensity
        },
        uNoiseScale: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseScale, 0, 1, 0.01, 20)
        },
        uNoiseSpeed: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.grungifyNoiseSpeed, 0, 1, 0, 10)
        },
        uLineIntensity: {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyLineIntensity
        },
        uLines: {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyLines
        },
        uColor1: {
            value: new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.twodeeColor1)
        },
        uColor2: {
            value: new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.twodeeColor2)
        },
        uSat: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.colorSaturation, 0, 1, 0, 5)
        }
    },
    vertexShader: $7c93ed56c9c27f38$var$texVertexShader,
    fragmentShader: $7c93ed56c9c27f38$var$texFragmentShader,
    transparent: true
});
const $7c93ed56c9c27f38$var$textureMesh = new $ilwiq.Mesh($7c93ed56c9c27f38$var$textureGeometry, $7c93ed56c9c27f38$var$textureMaterial);
// Shader Vapor
const $7c93ed56c9c27f38$var$generateHeightmap = ()=>{
    const dt_size = 64;
    const data_arr = new Float32Array(dt_size * dt_size);
    const length = dt_size * dt_size;
    for(let i = 0; i < length; i++){
        const val = $7c93ed56c9c27f38$var$randomFloat(0, 1);
        data_arr[i] = val;
    }
    const texture = new $ilwiq.DataTexture(data_arr, dt_size, dt_size, $ilwiq.RedFormat, $ilwiq.FloatType);
    texture.needsUpdate = true;
    return texture;
};
const $7c93ed56c9c27f38$var$fxVertexShader = /*glsl*/ `
    varying vec2 vUv;

    void main () {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        vUv = uv;
    }
`;
const $7c93ed56c9c27f38$var$fxFragmentShader = /*glsl*/ `
    uniform sampler2D sampler;
    uniform int uGlitch;
    uniform int uNType;
    uniform int uGType;
    uniform sampler2D uGDisplace;
    uniform float uGAmount;
    uniform float uGAngle;
    uniform float uGSeed;
    uniform float uGSeedX;
    uniform float uGSeedY;
    uniform float uGlitchionX;
    uniform float uGlitchionY;
    uniform float uGColumns;
    uniform float uTime;
    uniform vec2 uMouse;
    uniform float uNoiseIntensity;
    uniform int uVignette;
    uniform float uNoise;
    uniform float uNoiseSpeed;
    uniform float uNoiseScale;
    varying vec2 vUv;

    #define M_PI 3.14159265358979323846

    float rand(vec2 n) { 
        return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
    }

    const mat2 myt = mat2(.12121212, .13131313, -.13131313, .12121212);
    const vec2 mys = vec2(1e4, 1e6);

    vec2 rhash(vec2 uv) {
    uv *= myt;
    uv *= mys;
    return fract(fract(uv / mys) * uv);
    }

    vec3 hash(vec3 p) {
    return fract(
        sin(vec3(dot(p, vec3(1.0, 57.0, 113.0)), dot(p, vec3(57.0, 113.0, 1.0)),
                dot(p, vec3(113.0, 1.0, 57.0)))) *
        43758.5453);
    }

    vec3 voronoi3d(const in vec3 x, const in int m) {
    vec3 p = floor(x);
    vec3 f = fract(x);

    float id = 0.0;
    vec2 res = vec2(100.0);
    for (int k = -1; k <= 1; k++) {
        for (int j = -1; j <= 1; j++) {
        for (int i = -1; i <= 1; i++) {
            vec3 b = vec3(float(i), float(j), float(k));
            vec3 r = vec3(b) - f + hash(p + b);
            float d = dot(r, r);

            float cond = max(sign(res.x - d), 0.0);
            float nCond = 1.0 - cond;

            float cond2 = nCond * max(sign(res.y - d), 0.0);
            float nCond2 = 1.0 - cond2;

            id = (dot(p + b, vec3(1.0, 57.0, 113.0)) * cond) + (id * nCond);
            res = vec2(d, res.x) * cond + res * nCond;

            if(m == 1){
                res.y = cond2 * d + nCond2 * res.y;
            }
            else if(m == 2){
                res.y = -cond2 * d + nCond2 * res.y;
            } 
            else if(m == 3){
                res.y = cond2 * d + nCond*-nCond2*-nCond2 * res.y;
            }
            else {
                res.y = cond * d - -nCond2 * res.x;
            }
        }
        }
    }

    return vec3(sqrt(res), abs(id));
    }

    //	Simplex 3D Noise 
    //	by Ian McEwan, Ashima Arts
    //
    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}

    float snoise(vec3 v){ 
    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

    // First corner
    vec3 i  = floor(v + dot(v, C.yyy) );
    vec3 x0 =   v - i + dot(i, C.xxx) ;

    // Other corners
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min( g.xyz, l.zxy );
    vec3 i2 = max( g.xyz, l.zxy );

    //  x0 = x0 - 0. + 0.0 * C 
    vec3 x1 = x0 - i1 + 1.0 * C.xxx;
    vec3 x2 = x0 - i2 + 2.0 * C.xxx;
    vec3 x3 = x0 - 1. + 3.0 * C.xxx;

    // Permutations
    i = mod(i, 289.0 ); 
    vec4 p = permute( permute( permute( 
                i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
            + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
            + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));

    // Gradients
    // ( N*N points uniformly over a square, mapped onto an octahedron.)
    float n_ = 1.0/7.0; // N=7
    vec3  ns = n_ * D.wyz - D.xzx;

    vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)

    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)

    vec4 x = x_ *ns.x + ns.yyyy;
    vec4 y = y_ *ns.x + ns.yyyy;
    vec4 h = 1.0 - abs(x) - abs(y);

    vec4 b0 = vec4( x.xy, y.xy );
    vec4 b1 = vec4( x.zw, y.zw );

    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));

    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;

    vec3 p0 = vec3(a0.xy,h.x);
    vec3 p1 = vec3(a0.zw,h.y);
    vec3 p2 = vec3(a1.xy,h.z);
    vec3 p3 = vec3(a1.zw,h.w);

    //Normalise gradients
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
    p0 *= norm.x;
    p1 *= norm.y;
    p2 *= norm.z;
    p3 *= norm.w;

    // Mix final noise value
    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
                                    dot(p2,x2), dot(p3,x3) ) );
    }

    void main () {
        vec4 t0 = vec4(0);
        float v = (uVignette == 0 ? 0. : distance(vUv,vec2(0.5)));
        if(uNType<1){
            float a = snoise(vec3(vUv * uNoise, uTime * uNoiseSpeed)) * uNoiseScale;
            float b = snoise(vec3(vUv * uNoise, uTime * uNoiseSpeed + 100.)) * uNoiseScale;
            t0 = texture2D(sampler, vUv + vec2(a, b) + uMouse * 0.005);
        }
        else {
            vec3 a = voronoi3d(vec3(vUv * -uNoise, uTime * uNoiseSpeed), uNType) * uNoiseScale;
            vec3 b = -voronoi3d(vec3(vUv * uNoise, -uTime * uNoiseSpeed), uNType) * uNoiseScale;
            t0 = texture2D(sampler, vUv + a.xy + b.xy + uMouse * 0.005);
        }

        if(uGlitch>0) {
            vec2 p = vUv;
            float xs = floor(gl_FragCoord.x / 0.1);
            float ys = floor(gl_FragCoord.y / 0.1);
            //based on staffantans glitch shader for unity https://github.com/staffantan/unityglitch
            float disp = texture2D(uGDisplace, p*uGSeed*uGSeed).r;
            if(p.y<uGlitchionX+uGColumns && p.y>uGlitchionY-uGColumns*uGSeed) {
                if(uGSeedX>0.){
                    p.y = 1. - (p.y + uGlitchionY);
                }
                else {
                    p.y = uGlitchionY;
                }
            }
            if(p.x<uGlitchionY+uGColumns && p.x>uGlitchionY-uGColumns*uGSeed) {
                if(uGSeedY>0.){
                    p.x=uGlitchionX;
                }
                else {
                    p.x = 1. - (p.x + uGlitchionX);
                }
            }
            p.x+=disp*uGSeedX*(uGSeed/0.5);
            p.y+=disp*uGSeedY*(uGSeed/0.5);
            
            //base from RGB shift shader
            vec2 offset = uGAmount * vec2( cos(uGAngle), sin(uGAngle));
            vec4 cr = texture2D(sampler, p + offset);
            vec4 cga = texture2D(sampler, p);
            vec4 cb = texture2D(sampler, p - offset);
            vec4 finalColor = vec4(cr.r, cga.g, cb.b, cga.a);
            
            //add noise
            // vec4 snow = 200.*uGAmount*vec4(rand(vec2(xs * uGSeed,ys * uGSeed*50.))*0.2);
            // finalColor += snow;

            //this is starting to get somewhere
            if(uGType==0){
                gl_FragColor = vec4(t0.xyz - finalColor.xyz, uNoiseIntensity-v);
            }
            else if(uGType==1) {
                gl_FragColor = vec4(finalColor.xyz - t0.xyz, uNoiseIntensity-v);
            }
            else {
                gl_FragColor = vec4((t0.xyz - finalColor.xyz) / length(t0.xyz), uNoiseIntensity-v);
            }
            //this produces kinda alpha
            // gl_FragColor = vec4(t0.xyz * uColorPersist, uAlphaPersist * t0.a);
        }
        else {
            // gl_FragColor = vec4(t0.xyz, pow(uNoiseIntensity * 0.999, uTime));
            gl_FragColor = vec4(t0.xyz, uNoiseIntensity-v);
        }
    }
`;
const $7c93ed56c9c27f38$var$fxScene = new $ilwiq.Scene();
const $7c93ed56c9c27f38$var$fxGeometry = new $ilwiq.PlaneGeometry($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
const $7c93ed56c9c27f38$var$fxMaterial = new $ilwiq.ShaderMaterial({
    vertexShader: $7c93ed56c9c27f38$var$fxVertexShader,
    fragmentShader: $7c93ed56c9c27f38$var$fxFragmentShader,
    transparent: true,
    uniforms: {
        sampler: {
            value: null
        },
        uGlitch: {
            value: $7c93ed56c9c27f38$var$PARAMS.grungifyGlitch ? 1.0 : 0.0
        },
        uNType: {
            value: $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType
        },
        uGType: {
            value: $7c93ed56c9c27f38$var$PARAMS.gltichType
        },
        uGDisplace: {
            value: $7c93ed56c9c27f38$var$generateHeightmap()
        },
        uGAmount: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchSep / 50
        },
        uGAngle: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.glitchAngle, 0, 1, -Math.PI, Math.PI)
        },
        uGSeed: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchSeed
        },
        uGSeedX: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchSeedX
        },
        uGSeedY: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchSeedY
        },
        uGlitchionX: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchDistortionX
        },
        uGlitchionY: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchDistortionY
        },
        uGColumns: {
            value: $7c93ed56c9c27f38$var$PARAMS.glitchColumns
        },
        uTime: {
            value: 0
        },
        uMouse: {
            value: new $ilwiq.Vector2(-1, -1)
        },
        uNoiseIntensity: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseIntensity, 0, 1, 0.5, 1)
        },
        uVignette: {
            value: $7c93ed56c9c27f38$var$PARAMS.vaporNoiseVignette ? 1 : 0
        },
        uNoise: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseAmount, 0, 1, 0.1, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 100 : 25)
        },
        uNoiseSpeed: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseSpeed, 0, 1, 0, 20)
        },
        uNoiseScale: {
            value: $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.vaporNoiseScale, 0, 1, 0.002, $7c93ed56c9c27f38$var$PARAMS.vaporNoiseType >= 2 ? 0.5 : 0.1)
        }
    }
});
const $7c93ed56c9c27f38$var$fxMesh = new $ilwiq.Mesh($7c93ed56c9c27f38$var$fxGeometry, $7c93ed56c9c27f38$var$fxMaterial);
$7c93ed56c9c27f38$var$fxScene.add($7c93ed56c9c27f38$var$fxMesh);
const $7c93ed56c9c27f38$var$renderer = new $ilwiq.WebGLRenderer({
    canvas: $7c93ed56c9c27f38$var$canvas,
    antialias: true,
    alpha: true,
    premultipliedAlpha: false
});
$7c93ed56c9c27f38$var$renderer.outputEncoding = $ilwiq.sRGBEncoding;
$7c93ed56c9c27f38$var$renderer.setSize($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
$7c93ed56c9c27f38$var$renderer.setPixelRatio($7c93ed56c9c27f38$var$PIXEL_RATIO);
$7c93ed56c9c27f38$var$renderer.shadowMap.enabled = true;
$7c93ed56c9c27f38$var$renderer.setClearColor(new $ilwiq.Color($7c93ed56c9c27f38$var$PARAMS.bgColor));
$7c93ed56c9c27f38$var$renderer.setClearAlpha(0);
const $7c93ed56c9c27f38$var$camera = new $ilwiq.OrthographicCamera(-$7c93ed56c9c27f38$var$SIZES.width * 0.5, $7c93ed56c9c27f38$var$SIZES.width * 0.5, $7c93ed56c9c27f38$var$SIZES.height * 0.5, -$7c93ed56c9c27f38$var$SIZES.height * 0.5, 0.1, 1000);
$7c93ed56c9c27f38$var$camera.position.set(0, 0, 500);
$7c93ed56c9c27f38$var$camera.aspect = $7c93ed56c9c27f38$var$SIZES.width / $7c93ed56c9c27f38$var$SIZES.height;
let $7c93ed56c9c27f38$var$renderBufferA = new $ilwiq.WebGLRenderTarget($7c93ed56c9c27f38$var$SIZES.width * $7c93ed56c9c27f38$var$PIXEL_RATIO, $7c93ed56c9c27f38$var$SIZES.height * $7c93ed56c9c27f38$var$PIXEL_RATIO, {
    format: $ilwiq.RGBAFormat
});
let $7c93ed56c9c27f38$var$renderBufferB = new $ilwiq.WebGLRenderTarget($7c93ed56c9c27f38$var$SIZES.width * $7c93ed56c9c27f38$var$PIXEL_RATIO, $7c93ed56c9c27f38$var$SIZES.height * $7c93ed56c9c27f38$var$PIXEL_RATIO, {
    format: $ilwiq.RGBAFormat
});
var $7c93ed56c9c27f38$var$ppPrameters = {
    minFilter: $ilwiq.LinearFilter,
    magFilter: $ilwiq.LinearFilter,
    format: $ilwiq.RGBAFormat,
    stencilBuffer: true
};
const $7c93ed56c9c27f38$var$ppRenderTarget = new $ilwiq.WebGLRenderTarget($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height, $7c93ed56c9c27f38$var$ppPrameters);
const $7c93ed56c9c27f38$var$ppComposer = new (0, $2HSCJ.EffectComposer)($7c93ed56c9c27f38$var$renderer, $7c93ed56c9c27f38$var$ppRenderTarget);
const $7c93ed56c9c27f38$var$animationLoop = ()=>{
    if (!$7c93ed56c9c27f38$var$PARAMS.loaded) return;
    const elapsedTime = $7c93ed56c9c27f38$var$clock.getElapsedTime();
    if ($7c93ed56c9c27f38$var$PARAMS.vapor) {
        if ($7c93ed56c9c27f38$var$PARAMS.mouseReactive) {
            const mappedSpeed = $7c93ed56c9c27f38$var$remap($7c93ed56c9c27f38$var$PARAMS.mouseSpeed, 0, 1, 0, 50);
            const mouseSpeed = (elapsedTime - $7c93ed56c9c27f38$var$lastElapsed) * mappedSpeed;
            $7c93ed56c9c27f38$var$lastElapsed = elapsedTime;
            $7c93ed56c9c27f38$var$MOUSE_POS.currentX += ($7c93ed56c9c27f38$var$MOUSE_POS.targetX - $7c93ed56c9c27f38$var$MOUSE_POS.currentX) * mouseSpeed;
            $7c93ed56c9c27f38$var$MOUSE_POS.currentY += ($7c93ed56c9c27f38$var$MOUSE_POS.targetY - $7c93ed56c9c27f38$var$MOUSE_POS.currentY) * mouseSpeed;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uMouse.value.x = $7c93ed56c9c27f38$var$MOUSE_POS.currentX;
            $7c93ed56c9c27f38$var$fxMaterial.uniforms.uMouse.value.y = $7c93ed56c9c27f38$var$MOUSE_POS.currentY;
        // fxMaterial.uniforms.uGlitch.value = Math.random()<0.95;
        }
        $7c93ed56c9c27f38$var$fxMaterial.uniforms.sampler.value = $7c93ed56c9c27f38$var$renderBufferB.texture;
        $7c93ed56c9c27f38$var$fxMaterial.uniforms.uTime.value = elapsedTime;
        $7c93ed56c9c27f38$var$renderer.autoClearColor = false;
        $7c93ed56c9c27f38$var$renderer.setRenderTarget($7c93ed56c9c27f38$var$renderBufferA);
        $7c93ed56c9c27f38$var$renderer.clearColor();
        $7c93ed56c9c27f38$var$renderer.render($7c93ed56c9c27f38$var$fxScene, $7c93ed56c9c27f38$var$camera);
        $7c93ed56c9c27f38$var$renderer.render($7c93ed56c9c27f38$var$scene, $7c93ed56c9c27f38$var$camera);
        $7c93ed56c9c27f38$var$renderer.setRenderTarget(null);
        $7c93ed56c9c27f38$var$renderer.render($7c93ed56c9c27f38$var$fxScene, $7c93ed56c9c27f38$var$camera);
        if ($7c93ed56c9c27f38$var$PARAMS.showInitial) $7c93ed56c9c27f38$var$renderer.render($7c93ed56c9c27f38$var$scene, $7c93ed56c9c27f38$var$camera);
        if ($7c93ed56c9c27f38$var$isPP) $7c93ed56c9c27f38$var$ppComposer.render();
        const temp = $7c93ed56c9c27f38$var$renderBufferA;
        $7c93ed56c9c27f38$var$renderBufferA = $7c93ed56c9c27f38$var$renderBufferB;
        $7c93ed56c9c27f38$var$renderBufferB = temp;
    } else {
        $7c93ed56c9c27f38$var$renderer.autoClearColor = true;
        $7c93ed56c9c27f38$var$renderer.render($7c93ed56c9c27f38$var$scene, $7c93ed56c9c27f38$var$camera);
    }
    // if(fmarkMaterial) { fmarkMaterial.uniforms.uTime.value = elapsedTime; }
    $7c93ed56c9c27f38$var$custom3DUniforms.uTime.value = elapsedTime;
    if ($7c93ed56c9c27f38$var$fmarkMaterial) $7c93ed56c9c27f38$var$fmarkMaterial.needsUpdate = true;
    if ($7c93ed56c9c27f38$var$patternMaterial) $7c93ed56c9c27f38$var$patternMaterial.uniforms.uTime.value = elapsedTime;
    if ($7c93ed56c9c27f38$var$textureMaterial) $7c93ed56c9c27f38$var$textureMaterial.uniforms.uTime.value = elapsedTime;
};
window.addEventListener("load", ()=>{
    $7c93ed56c9c27f38$var$initMainTls();
    $7c93ed56c9c27f38$var$initJBI();
    $7c93ed56c9c27f38$var$initWKYII();
    document.querySelector("#btn-folder").addEventListener("click", $7c93ed56c9c27f38$var$handleBtnClick);
    document.querySelector("#btn-house").addEventListener("click", $7c93ed56c9c27f38$var$handleBtnClick);
    document.querySelector("#btn-star").addEventListener("click", $7c93ed56c9c27f38$var$handleBtnClick);
    var collection = document.querySelector("#section-notifications");
    var items = [
        ...collection.children
    ].slice(1);
    $7c93ed56c9c27f38$var$initCollectionItems(collection, items, "section-notifications");
    collection = document.querySelector("#section-messages");
    items = [
        ...collection.children
    ].slice(1);
    $7c93ed56c9c27f38$var$initCollectionItems(collection, items, "section-messages");
    collection = document.querySelector("#section-inbox");
    items = [
        ...collection.children
    ].slice(1);
    $7c93ed56c9c27f38$var$initCollectionItems(collection, items, "section-inbox");
// TODO: Incorporate threejs when background is part of it
// // Start animation loop
// renderer.setAnimationLoop(animationLoop);
// // Light it up
// updateExperiment();
// window.setTimeout(() => { overrideExperiment(); }, 150);
});
var $7c93ed56c9c27f38$var$mainTls = [];
var $7c93ed56c9c27f38$var$wYWA, $7c93ed56c9c27f38$var$jBI, $7c93ed56c9c27f38$var$wKYII;
const $7c93ed56c9c27f38$var$initMainTls = ()=>{
    const dur = 0.65;
    var item = document.querySelector("#title-home");
    var offset = item.getBoundingClientRect().width;
    var tl = gsap.timeline({
        paused: true
    });
    tl.fromTo(item, {
        opacity: 1
    }, {
        opacity: 0,
        duration: dur * 0.9,
        delay: 0.3
    }, 0);
    tl.fromTo(item, {
        x: 0
    }, {
        x: -offset * 0.75,
        duration: dur,
        ease: "back.inOut(0.8)",
        delay: 0.2
    }, 0);
    $7c93ed56c9c27f38$var$mainTls.push(tl);
    $7c93ed56c9c27f38$var$wYWA = document.querySelector("#wYWA");
    var offset = $7c93ed56c9c27f38$var$wYWA.getBoundingClientRect().width;
    var tl = gsap.timeline({
        paused: true
    });
    tl.fromTo($7c93ed56c9c27f38$var$wYWA, {
        opacity: 1
    }, {
        opacity: 0,
        duration: dur * 0.9,
        delay: 0.2
    }, 0);
    tl.fromTo($7c93ed56c9c27f38$var$wYWA, {
        x: 0
    }, {
        x: -offset * 0.75,
        duration: dur,
        ease: "back.inOut(0.8)",
        delay: 0.1
    }, 0);
    $7c93ed56c9c27f38$var$mainTls.push(tl);
    $7c93ed56c9c27f38$var$jBI = document.querySelector("#jBI");
    var offset = $7c93ed56c9c27f38$var$jBI.getBoundingClientRect().width;
    var tl = gsap.timeline({
        paused: true
    });
    tl.fromTo($7c93ed56c9c27f38$var$jBI, {
        opacity: 1
    }, {
        opacity: 0,
        duration: dur * 0.9,
        delay: 0
    }, 0);
    tl.fromTo($7c93ed56c9c27f38$var$jBI, {
        x: 0
    }, {
        x: -offset * 0.75,
        duration: dur,
        ease: "back.inOut(0.8)",
        delay: 0
    }, 0);
    $7c93ed56c9c27f38$var$mainTls.push(tl);
    item = document.querySelector("#title-reco");
    var offset = item.getBoundingClientRect().width;
    var tl = gsap.timeline({
        paused: true
    });
    tl.fromTo(item, {
        opacity: 0
    }, {
        opacity: 1,
        duration: dur * 0.9,
        delay: dur
    }, 0);
    tl.fromTo(item, {
        x: offset * 0.75
    }, {
        x: 0,
        duration: dur,
        ease: "back.inOut(0.8)",
        delay: 0.3
    }, 0);
    $7c93ed56c9c27f38$var$mainTls.push(tl);
    $7c93ed56c9c27f38$var$wKYII = document.querySelector("#wKYII");
    var offset = $7c93ed56c9c27f38$var$wKYII.getBoundingClientRect().x;
    var tl = gsap.timeline({
        paused: true
    });
    tl.fromTo($7c93ed56c9c27f38$var$wKYII, {
        opacity: 0
    }, {
        opacity: 1,
        duration: dur * 0.9,
        delay: dur
    }, 0);
    tl.fromTo($7c93ed56c9c27f38$var$wKYII, {
        x: offset * 0.75
    }, {
        x: -offset,
        duration: dur,
        ease: "back.inOut(0.8)",
        delay: 0.3
    }, 0);
    $7c93ed56c9c27f38$var$mainTls.push(tl);
    $7c93ed56c9c27f38$var$jBI.addEventListener("pointerenter", ()=>{
        $7c93ed56c9c27f38$var$wYWA.style.pointerEvents = "none";
    });
    $7c93ed56c9c27f38$var$jBI.addEventListener("pointerleave", ()=>{
        $7c93ed56c9c27f38$var$wYWA.style.pointerEvents = "all";
    });
};
const $7c93ed56c9c27f38$var$CARD_ROT = 6;
const $7c93ed56c9c27f38$var$Z_RANGE = {
    min: -150,
    max: -400
};
var $7c93ed56c9c27f38$var$curWKYII;
const $7c93ed56c9c27f38$var$initWKYII = ()=>{
    // algorithm for random-but-decent-looking-distribution
    // place first item within a certain tolerance of the center of the parent space
    // for each subsequent item, place item within a certain tolerance plus additional offset of the center 
    // if item overlaps another item by a tolerance failure then shift it in the opposite direction until tolerance is met
    // don't exceed item's dimensions
    const wKYIIDimen = $7c93ed56c9c27f38$var$wKYII.getBoundingClientRect();
    const t = {
        tol: 0.5,
        incr: 0.5,
        tolEr: 0.2
    };
    const cards = gsap.utils.toArray(".wKYII-card");
    cards.forEach((ec, i)=>{
        gsap.set(ec, {
            xPercent: -50,
            yPercent: -50
        });
        const s = ec.getBoundingClientRect();
        const rx = Math.random();
        const ry = Math.random();
        var dx = (wKYIIDimen.width - s.width) * 0.5 * t.tol;
        dx = dx + dx * (i * t.incr);
        var dy = (wKYIIDimen.height - s.height) * 0.5 * t.tol;
        dy = dy + dy * (i * t.incr);
        const x = $7c93ed56c9c27f38$var$remap(rx, 0, 1, -dx, dx);
        const y = $7c93ed56c9c27f38$var$remap(ry, 0, 1, -dy, dy);
        ec.style.left = `${x + wKYIIDimen.width * 0.5}px`;
        ec.style.top = `${y + wKYIIDimen.height * 0.5}px`;
        const rand = Math.random();
        const tz = $7c93ed56c9c27f38$var$remap(rand, 0, 1, $7c93ed56c9c27f38$var$Z_RANGE.min, $7c93ed56c9c27f38$var$Z_RANGE.max);
        if (i < cards.length - 1) {
            gsap.set(ec, {
                translateZ: tz
            });
            ec.style.zIndex = 0;
        } else {
            $7c93ed56c9c27f38$var$curWKYII = ec;
            $7c93ed56c9c27f38$var$curWKYII.style.zIndex = 1;
        }
        ec.dataset.tz = tz;
        ec.addEventListener("pointermove", (e)=>{
            const r = e.currentTarget.getBoundingClientRect();
            const mouseX = -$7c93ed56c9c27f38$var$remap(e.clientX - r.left, 0, r.width, -$7c93ed56c9c27f38$var$CARD_ROT, $7c93ed56c9c27f38$var$CARD_ROT);
            const mouseY = $7c93ed56c9c27f38$var$remap(e.clientY - r.top, 0, r.height, -$7c93ed56c9c27f38$var$CARD_ROT, $7c93ed56c9c27f38$var$CARD_ROT);
            gsap.to(e.currentTarget, {
                duration: 0.5,
                rotationY: mouseX,
                rotationX: mouseY,
                ease: "power2.out"
            });
        });
        ec.addEventListener("pointerleave", (e)=>{
            gsap.to(e.currentTarget, {
                duration: 0.65,
                rotationY: 0,
                rotationX: 0,
                ease: "elastic.out(0.6,0.3)"
            });
        });
        ec.addEventListener("pointerenter", (e)=>{
            if ($7c93ed56c9c27f38$var$curWKYII === e.currentTarget) return;
            gsap.to($7c93ed56c9c27f38$var$curWKYII, {
                duration: 1.65,
                translateZ: $7c93ed56c9c27f38$var$curWKYII.dataset.tz,
                ease: "elastic.out(0.4,0.3)"
            });
            $7c93ed56c9c27f38$var$curWKYII.style.zIndex = 0;
            $7c93ed56c9c27f38$var$curWKYII = e.currentTarget;
            $7c93ed56c9c27f38$var$curWKYII.style.zIndex = 1;
            gsap.to($7c93ed56c9c27f38$var$curWKYII, {
                duration: 0.45,
                translateZ: 0,
                ease: "elastic.out(0.5,0.6)"
            });
        });
    });
};
var $7c93ed56c9c27f38$var$collections = [];
const $7c93ed56c9c27f38$var$initCollectionItems = (c, d, id)=>{
    var tls = [];
    const offset = d[0].getBoundingClientRect().height;
    for(var i = 0; i < d.length; i++){
        const tl = gsap.timeline({
            paused: true
        });
        const op = d.length == 2 ? 0.4 : 1.1 - $7c93ed56c9c27f38$var$remap(i, 0, d.length - 1, 0.8, 0.4);
        const de = (d.length - 1 - i) * 0.05;
        tl.fromTo(d[i], {
            opacity: i < d.length - 1 ? op : 1
        }, {
            opacity: 1,
            delay: de,
            duration: 0.25
        }, 0);
        tl.fromTo(d[i], {
            y: i * -offset * 0.8
        }, {
            y: 0,
            ease: "elastic.out(1,0.8)",
            delay: de,
            duration: 0.65
        }, 0);
        tl.fromTo(d[i], {
            scale: 1
        }, {
            scale: 1.05,
            ease: "elastic.out(0.5,0.3)",
            delay: de,
            duration: 0.65
        }, 0);
        tl.seek(0);
        tls.push(tl);
    }
    $7c93ed56c9c27f38$var$collections.push({
        id: id,
        tls: tls
    });
    c.addEventListener("pointerenter", (e)=>{
        $7c93ed56c9c27f38$var$collections.filter((c)=>c.id === e.target.id)[0].tls.forEach((tl)=>{
            tl.timeScale(1).play();
        });
    });
    c.addEventListener("pointerleave", (e)=>{
        $7c93ed56c9c27f38$var$collections.filter((c)=>c.id === e.target.id)[0].tls.forEach((tl)=>{
            tl.timeScale(1.2).reverse();
        });
    });
};
const $7c93ed56c9c27f38$var$jbiSizes = {
    p: null,
    w: null
};
const $7c93ed56c9c27f38$var$initJBI = ()=>{
    $7c93ed56c9c27f38$var$jbiSizes.p = document.querySelector("#jbi-personal").getBoundingClientRect();
    $7c93ed56c9c27f38$var$jbiSizes.w = document.querySelector("#jbi-work").getBoundingClientRect();
    $7c93ed56c9c27f38$var$initJBICore(document.querySelector("#jbi-personal"));
    $7c93ed56c9c27f38$var$initJBICore(document.querySelector("#jbi-work"));
};
var $7c93ed56c9c27f38$var$curSizes, $7c93ed56c9c27f38$var$curTargets;
const $7c93ed56c9c27f38$var$initJBICore = (d)=>{
    gsap.set(".jbi-img", {
        xPercent: -50,
        yPercent: -50
    });
    const t = 0.8;
    var info = d.id == "jbi-personal" ? $7c93ed56c9c27f38$var$jbiSizes.p : $7c93ed56c9c27f38$var$jbiSizes.w;
    var offset = {
        w: info.width - info.width * t,
        h: info.height - info.height * t
    };
    var items = [
        ...d.children
    ].slice(0, d.children.length - 1);
    items.forEach((item)=>{
        const s = item.getBoundingClientRect();
        const x = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, offset.w, info.width - offset.w * 2);
        const y = $7c93ed56c9c27f38$var$remap(Math.random(), 0, 1, offset.h, info.height - offset.h * 2);
        item.style.left = `${x}px`;
        item.style.top = `${y + s.height * 0.15}px`;
    });
    d.addEventListener("pointerenter", (e)=>{
        $7c93ed56c9c27f38$var$curSizes = e.target.id == "jbi-personal" ? $7c93ed56c9c27f38$var$jbiSizes.p : $7c93ed56c9c27f38$var$jbiSizes.w;
        $7c93ed56c9c27f38$var$curTargets = gsap.utils.toArray(`${e.target.id == "jbi-personal" ? "#jbi-personal" : "#jbi-work"} .jbi-img`);
        $7c93ed56c9c27f38$var$curTargets.forEach((el)=>{
            gsap.to(el, {
                borderColor: "#ffffff55",
                duration: 0.25
            });
        });
        window.addEventListener("mousemove", $7c93ed56c9c27f38$var$followMouse);
    });
    d.addEventListener("pointerleave", (e)=>{
        $7c93ed56c9c27f38$var$curTargets = gsap.utils.toArray(`${e.target.id == "jbi-personal" ? "#jbi-personal" : "#jbi-work"} .jbi-img`);
        $7c93ed56c9c27f38$var$curTargets.forEach((el)=>{
            gsap.to(el, {
                borderColor: "#ffffff0f",
                duration: 0.25
            });
        });
        window.removeEventListener("mousemove", $7c93ed56c9c27f38$var$followMouse);
        gsap.to($7c93ed56c9c27f38$var$curTargets, {
            duration: 5,
            x: 0,
            y: 0,
            ease: "elastic.out(1,0.8)",
            overwrite: "auto",
            stagger: 0.05
        });
    });
};
//TODO: see new algorithm notes above
const $7c93ed56c9c27f38$var$followMouse = (e)=>{
    gsap.to($7c93ed56c9c27f38$var$curTargets, {
        duration: 10,
        x: e.clientX - $7c93ed56c9c27f38$var$curSizes.left - $7c93ed56c9c27f38$var$curSizes.width * 0.5,
        y: e.clientY - $7c93ed56c9c27f38$var$curSizes.top - $7c93ed56c9c27f38$var$curSizes.height * 0.5,
        ease: "elastic.out(1,0.8)",
        overwrite: "auto",
        stagger: 0.05
    });
};
var $7c93ed56c9c27f38$var$currentBtn = document.querySelector("#btn-house");
const $7c93ed56c9c27f38$var$handleBtnClick = (e)=>{
    if (e.target.id == "btn-folder" || e.target == $7c93ed56c9c27f38$var$currentBtn) return;
    $7c93ed56c9c27f38$var$currentBtn.classList.remove("selected");
    $7c93ed56c9c27f38$var$currentBtn = e.target;
    $7c93ed56c9c27f38$var$currentBtn.classList.add("selected");
    if (e.target.id == "btn-star") {
        $7c93ed56c9c27f38$var$mainTls.forEach((tl)=>{
            tl.timeScale(1).play();
        });
        gsap.to(document.querySelector(".bg1"), {
            opacity: 0,
            duration: 0.3,
            delay: 0.2
        });
        gsap.to(document.querySelector(".bg2"), {
            opacity: 1,
            duration: 0.5,
            delay: 0
        });
    } else {
        $7c93ed56c9c27f38$var$mainTls.forEach((tl)=>{
            tl.timeScale(0.8).reverse();
        });
        gsap.to(document.querySelector(".bg1"), {
            opacity: 1,
            duration: 0.5,
            delay: 0
        });
        gsap.to(document.querySelector(".bg2"), {
            opacity: 0,
            duration: 0.3,
            delay: 0.2
        });
    }
    document.body.style.pointerEvents = "none";
    window.setTimeout(()=>{
        document.body.style.pointerEvents = "all";
    }, 750);
};
window.addEventListener("pointermove", (e)=>{
    const x = e.pageX / $7c93ed56c9c27f38$var$SIZES.width * 2 - 1;
    const y = (1 - e.pageY / $7c93ed56c9c27f38$var$SIZES.height) * 2 - 1;
    $7c93ed56c9c27f38$var$MOUSE_POS.targetX = x;
    $7c93ed56c9c27f38$var$MOUSE_POS.targetY = y;
    if ($7c93ed56c9c27f38$var$fmarkMesh) {
        gsap.to($7c93ed56c9c27f38$var$fmarkMesh.rotation, {
            y: -Math.PI * 0.25 * x,
            ease: "power2.inout",
            duration: 0.75
        });
        gsap.to($7c93ed56c9c27f38$var$fmarkMesh.rotation, {
            x: Math.PI * 0.25 * y,
            ease: "power2.inout",
            duration: 0.75
        });
    }
    if ($7c93ed56c9c27f38$var$PARAMS.twodeerotate && $7c93ed56c9c27f38$var$textureMesh) {
        if ($7c93ed56c9c27f38$var$textureMesh) {
            gsap.to($7c93ed56c9c27f38$var$textureMesh.rotation, {
                y: -Math.PI * 0.1 * x,
                ease: "power2.inout",
                duration: 0.75
            });
            gsap.to($7c93ed56c9c27f38$var$textureMesh.rotation, {
                x: Math.PI * 0.1 * y,
                ease: "power2.inout",
                duration: 0.75
            });
        }
        if ($7c93ed56c9c27f38$var$patternMesh) {
            gsap.to($7c93ed56c9c27f38$var$patternMesh.rotation, {
                y: -Math.PI * 0.1 * x,
                ease: "power2.inout",
                duration: 0.75
            });
            gsap.to($7c93ed56c9c27f38$var$patternMesh.rotation, {
                x: Math.PI * 0.1 * y,
                ease: "power2.inout",
                duration: 0.75
            });
        }
    }
});
window.addEventListener("resize", ()=>{
    $7c93ed56c9c27f38$var$SIZES.width = window.innerWidth;
    $7c93ed56c9c27f38$var$SIZES.height = window.innerHeight;
    $7c93ed56c9c27f38$var$camera.aspect = $7c93ed56c9c27f38$var$SIZES.width / $7c93ed56c9c27f38$var$SIZES.height;
    $7c93ed56c9c27f38$var$camera.updateProjectionMatrix();
    $7c93ed56c9c27f38$var$renderer.setSize($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
    $7c93ed56c9c27f38$var$renderBufferA.setSize($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
    $7c93ed56c9c27f38$var$renderBufferB.setSize($7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
    if ($7c93ed56c9c27f38$var$PARAMS.mode == 0) $7c93ed56c9c27f38$var$renderImageTexture();
});
var $7c93ed56c9c27f38$var$fxHidden = false;
var $7c93ed56c9c27f38$var$pHidden = true;
document.addEventListener("keydown", (e)=>{
    if (e.ctrlKey && e.key === "e") {
        $7c93ed56c9c27f38$var$canvas.style.display = $7c93ed56c9c27f38$var$fxHidden ? "block" : "none";
        $7c93ed56c9c27f38$var$fxHidden = !$7c93ed56c9c27f38$var$fxHidden;
    }
    if (e.ctrlKey && e.key === "p") {
        $7c93ed56c9c27f38$var$tpContainer.style.display = $7c93ed56c9c27f38$var$pHidden ? "block" : "none";
        $7c93ed56c9c27f38$var$pHidden = !$7c93ed56c9c27f38$var$pHidden;
    }
});
const $7c93ed56c9c27f38$var$renderImageTexture = ()=>{
    var w, h, a;
    if ($7c93ed56c9c27f38$var$textureImg.height > $7c93ed56c9c27f38$var$textureImg.width) {
        a = $7c93ed56c9c27f38$var$textureImg.width / $7c93ed56c9c27f38$var$textureImg.height;
        switch($7c93ed56c9c27f38$var$PARAMS.image){
            case 0:
                h = $7c93ed56c9c27f38$var$SIZES.height * $7c93ed56c9c27f38$var$PARAMS.zoom;
                break;
            case 1:
                h = $7c93ed56c9c27f38$var$SIZES.height * $7c93ed56c9c27f38$var$PARAMS.zoom * 0.5;
                break;
            case 2:
                h = $7c93ed56c9c27f38$var$SIZES.height * $7c93ed56c9c27f38$var$PARAMS.zoom * 0.35;
                break;
        }
        w = h * a;
    } else {
        a = $7c93ed56c9c27f38$var$textureImg.height / $7c93ed56c9c27f38$var$textureImg.width;
        w = $7c93ed56c9c27f38$var$SIZES.width * ($7c93ed56c9c27f38$var$PARAMS.image == 1 ? $7c93ed56c9c27f38$var$PARAMS.zoom * 0.5 : $7c93ed56c9c27f38$var$PARAMS.zoom);
        h = w * a;
    }
    $7c93ed56c9c27f38$var$ctx.clearRect(0, 0, $7c93ed56c9c27f38$var$SIZES.width, $7c93ed56c9c27f38$var$SIZES.height);
    $7c93ed56c9c27f38$var$ctx.drawImage($7c93ed56c9c27f38$var$textureImg, ($7c93ed56c9c27f38$var$SIZES.width - w) * 0.5, ($7c93ed56c9c27f38$var$SIZES.height - h) * 0.5, w, h);
    $7c93ed56c9c27f38$var$textureMaterial.uniforms.sampler.value = new $ilwiq.CanvasTexture($7c93ed56c9c27f38$var$textureCanvas);
};


//# sourceMappingURL=proto.bca447a5.js.map
